
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

parcelRegister("gxXVf", function(module, exports) {

$parcel$export(module.exports, "openMacroBrowserForInitialConfiguration", () => $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4);
$parcel$export(module.exports, "openMacroBrowserToEditExistingMacro", () => $e47b9ace59ffb2ab$export$bb0b49ebec872281);

var $lwdd5 = parcelRequire("lwdd5");

var $6OgRG = parcelRequire("6OgRG");
var $6mEZ3 = parcelRequire("6mEZ3");
var $foRF9 = parcelRequire("foRF9");
var $3IXUB = parcelRequire("3IXUB");

var $8pcS0 = parcelRequire("8pcS0");

var $fgbpl = parcelRequire("fgbpl");

var $7W8i8 = parcelRequire("7W8i8");

var $6Ywr0 = parcelRequire("6Ywr0");

var $7bL1M = parcelRequire("7bL1M");

var $bx6Tx = parcelRequire("bx6Tx");

// An empty adf node to fallback to if no selected macro is provided
const $e47b9ace59ffb2ab$var$fallbackADNode = {
    type: 'extension',
    content: (0, $8pcS0.EMPTY_ADF_CONTENT)
};
const $e47b9ace59ffb2ab$export$a40defd79158e045 = {
    showLabels: {
        value: 'true'
    },
    max: {
        value: '15'
    },
    sort: {
        value: null
    },
    showSpace: {
        value: 'true'
    },
    reverse: {
        value: 'false'
    },
    excerptType: {
        value: 'none'
    }
};
function $e47b9ace59ffb2ab$export$4793f1f3f9872794() {
    return (0, $3IXUB.getMacroMetaData)().then((macros)=>macros.filter((item)=>(0, $8pcS0.allowedMacrosForInsertMenu).includes(item.macroName)));
}
function $e47b9ace59ffb2ab$export$ace579897112f22(macroDefinition) {
    return {
        type: 'embedCard',
        attrs: {
            url: macroDefinition.params && macroDefinition.params.url,
            layout: 'wide'
        }
    };
}
const $e47b9ace59ffb2ab$var$fireAnchorAnalyticsEvent = (createAnalyticsEvent, action, contentId, nameStatus)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: action,
            actionSubject: `${action}Anchor`,
            source: 'extensions-editor',
            attributes: {
                contentId: contentId,
                nameStatus: nameStatus
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireJIMAnalyticsEvent = (contentId, prevNodeType, newNodeType, createAnalyticsEvent)=>{
    const tableToIssueCount = prevNodeType === 'extension' && newNodeType === 'inlineExtension';
    const issueCountToTable = prevNodeType === 'inlineExtension' && newNodeType === 'extension';
    if (tableToIssueCount || issueCountToTable) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'changedJiraIssueMacroExtensionView',
            source: 'JiraIssueMacro',
            objectId: contentId,
            attributes: {
                tableToIssueCount: tableToIssueCount,
                issueCountToTable: issueCountToTable
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireContentByLabelAnalyticsEvent = (contentId, parameters, createAnalyticsEvent)=>{
    const getUGCFreeParameters = ()=>{
        const { cql: cql, title: title, ...rest } = parameters;
        return {
            ...$e47b9ace59ffb2ab$export$a40defd79158e045,
            ...rest
        };
    };
    if (parameters) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'closed',
            actionSubject: 'modal',
            actionSubjectId: 'macroBrowser',
            source: 'ContentByLabel',
            objectId: contentId,
            attributes: {
                extensionKey: 'contentbylabel',
                parameters: {
                    ...getUGCFreeParameters()
                }
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireErrorAnalytics = (contentId, actionSubject, createAnalyticsEvent, error, extensionKey)=>{
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'error',
            actionSubject: actionSubject,
            source: 'editor-extensions',
            objectId: contentId,
            attributes: {
                error: error?.message ?? error,
                stack: error?.stack,
                extensionKey: extensionKey
            }
        }
    }).fire();
};
async function $e47b9ace59ffb2ab$export$ff9b124c4a74b7b1(macroDefinition, isEditingMacro, extensionAnalyticsInfo) {
    if (macroDefinition.name === 'anchor') {
        const anchorNameProvidedByUser = macroDefinition.params[''];
        // Strip spaces off the beginning and end of the name
        let anchorNameWithoutSpaces = anchorNameProvidedByUser.replace(/^\s+/g, '');
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/\s+$/g, '');
        // Changing any remaining spaces to '-' to match header logic
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/\s+/g, '-');
        // Stripping out any single or double quotes for security (VULN-539679)
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/[\"\']+/g, '');
        if (extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) {
            let nameStatus;
            if (anchorNameWithoutSpaces === '') nameStatus = 'missing';
            else {
                anchorNameWithoutSpaces = anchorNameWithoutSpaces.substring(0, (0, $bx6Tx.MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH));
                try {
                    decodeURIComponent(anchorNameWithoutSpaces);
                    nameStatus = 'valid';
                } catch  {
                    nameStatus = 'invalid';
                }
            }
            $e47b9ace59ffb2ab$var$fireAnchorAnalyticsEvent(extensionAnalyticsInfo.createAnalyticsEvent, extensionAnalyticsInfo.action, extensionAnalyticsInfo?.contentId, nameStatus);
        }
        return {
            type: 'inlineExtension',
            attrs: {
                extensionType: 'com.atlassian.confluence.macro.core',
                extensionKey: 'anchor',
                parameters: {
                    macroParams: {
                        '': {
                            value: anchorNameWithoutSpaces
                        }
                    },
                    macroMetadata: {
                        title: 'Anchor'
                    }
                }
            }
        };
    } else if (macroDefinition.name === 'jiraroadmap') {
        /** jiraroadmap is always in confluence/next/packages/editor-features/src/utils/smartCardOptions.ts */ if (!isEditingMacro) return $e47b9ace59ffb2ab$export$ace579897112f22(macroDefinition);
    /*
        in order to render a single issue as a smart link the following conditions must be true or we default to inlineExtension
          - issue must be from a cloud server (params.key is defined and domain must be of a cloud instance)
          - required module from monolith (applinks-bridge-for-spa) must be loaded
          - the browser origin and issue link must be in the same environment (e.g. prod and prod, staging and staging) - only an issue for devs
      */ } else if (macroDefinition.name === 'jira' && !!macroDefinition.params.key) {
        if ((0, $6Ywr0.isRequiredModuleLoaded)('confluence/jim/jira/applinks-bridge-for-spa')) try {
            const ApplinksBridge = (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).require('confluence/jim/jira/applinks-bridge-for-spa');
            const issueUrl = await ApplinksBridge.getUrlForKey(macroDefinition.params.key, macroDefinition.params.serverId);
            if (await ApplinksBridge.isCloudAppLinkFromServerId(macroDefinition.params.serverId) && issueUrl) {
                const isIssueSameEnv = issueUrl.indexOf('atlassian.net') !== -1 === ((0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).location.origin.indexOf('atlassian.net') !== -1);
                // allow smart link insertion from localhost
                if (isIssueSameEnv || false) return {
                    type: 'inlineCard',
                    attrs: {
                        url: issueUrl
                    }
                };
            }
        } catch (e) {}
    }
    return null;
}
function $e47b9ace59ffb2ab$export$e33e56a93f919d6f(macro, config, extensionAnalyticsInfo) {
    const name = macro.macroName;
    // CFE-2344: despite not having a required parameter, the children macro should open the macro browser
    // so that the user can select a parent page. Without this, on a brand new page, the children display
    // macro renders a loading state, then completely disappears and looks broken.
    // CONFDEV-62041: tasks report macro also doesn't have a required parameter, but without any parameters
    // it tries to search the entirety of Confluence for tasks and usually times out, so let's ask for parameters anyway.
    if (macro.anyParameterRequired || name === 'children' || name === 'tasks-report-macro') return $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4(macro, config, undefined, extensionAnalyticsInfo);
    return (0, $foRF9.fetchMacroAttributes)({
        macroDefinition: {
            name: name,
            body: '',
            params: {}
        },
        contentId: config.contentId
    });
}
function $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(selectedMacroDefinition) {
    const { name: name, body: body, params: params, defaultParameterValue: defaultParameterValue, schemaVersion: schemaVersion } = selectedMacroDefinition;
    return {
        name: name || '',
        body: body || '',
        params: params,
        defaultParameterValue: defaultParameterValue || '',
        schemaVersion: schemaVersion
    };
}
async function $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, contentId, selectedMacro) {
    const newMacroNode = await (0, $foRF9.fetchMacroAttributes)({
        macroDefinition: macroDefinition,
        contentId: contentId,
        selectedMacro: null
    });
    if ((0, $fgbpl.isBodiedExtension)(newMacroNode.type)) {
        // Updating the content of the macro if it was changed with saveMacro
        // If saveMacro does not include the body, macroDefinition.body will
        // be substituted with some function
        if (typeof macroDefinition.body === 'string') {
            let convertedBody;
            try {
                convertedBody = await (0, $6mEZ3.convertBody)('storage', 'atlas_doc_format', macroDefinition.body, contentId) || '';
                newMacroNode.content = JSON.parse(convertedBody).content;
            } catch (error) {
                const logger = (0, $7W8i8.getLogger)('getMacroBrowserSettings.onComplete');
                logger.error`Can't convert provided body from storage format to ADF: ${convertedBody}`;
                // if provided body can't be converted to ADF return the previous content
                if (selectedMacro?.content) newMacroNode.content = selectedMacro?.content;
            }
        } else if (selectedMacro?.content) newMacroNode.content = selectedMacro?.content;
    }
    return newMacroNode;
}
async function $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, macroBrowserResolve, macroBrowserReject, extensionAnalyticsInfo, onCompleteCallback, updateMacro) {
    const blocklistRestore = await (0, $6OgRG.applyBlocklist)(macroBrowser);
    let isInserting;
    let insertUpdatedMacroFailureCount = 0;
    return {
        autoClose: false,
        onComplete: async (rowMacroDefinition)=>{
            isInserting = true;
            macroBrowser.UI.showBrowserSpinner(true);
            const macroDefinition = $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(rowMacroDefinition);
            try {
                let newMacroNode = await $e47b9ace59ffb2ab$export$ff9b124c4a74b7b1(macroDefinition, selectedMacro?.attrs?.extensionKey === 'jiraroadmap', extensionAnalyticsInfo);
                // If no transformation happen process as general macro
                if (!newMacroNode) {
                    newMacroNode = await $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, config.contentId, selectedMacro);
                    if (selectedMacro?.attrs?.extensionKey === 'jira' && extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) $e47b9ace59ffb2ab$var$fireJIMAnalyticsEvent(config.contentId, selectedMacro?.type, newMacroNode?.type, extensionAnalyticsInfo?.createAnalyticsEvent);
                    if (macroDefinition?.name === 'contentbylabel' && extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) $e47b9ace59ffb2ab$var$fireContentByLabelAnalyticsEvent(config.contentId, newMacroNode?.attrs?.parameters?.macroParams, extensionAnalyticsInfo?.createAnalyticsEvent);
                }
                macroBrowserResolve(newMacroNode);
                macroBrowser.close();
                blocklistRestore();
                onCompleteCallback?.({
                    macro: macroDefinition?.name,
                    isBodiedExtension: (0, $fgbpl.isBodiedExtension)(newMacroNode?.type)
                });
            } catch (err) {
                if ((0, $8pcS0.MODERENIZED_MACRO_KEYS).includes(selectedMacro?.attrs?.extensionKey)) $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'onComplete', extensionAnalyticsInfo?.createAnalyticsEvent, err, selectedMacro?.attrs?.extensionKey);
                macroBrowserReject(err);
            }
        },
        onCancel: ()=>{
            blocklistRestore();
            // Macro browser can call cancel on insert, so we need to keep state
            // and only reject when someone isn't trying to insert
            if (!isInserting) macroBrowserReject({
                reason: 'cancel'
            });
        },
        insertUpdatedMacro: async (rowMacroDefinition)=>{
            const macroDefinition = $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(rowMacroDefinition);
            try {
                const newMacroNode = await $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, config.contentId, selectedMacro);
                updateMacro?.(newMacroNode);
                insertUpdatedMacroFailureCount = 0;
            } catch (error) {
                insertUpdatedMacroFailureCount++;
                if (insertUpdatedMacroFailureCount > 5) {
                    insertUpdatedMacroFailureCount = 0;
                    $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'insertUpdatedMacro', extensionAnalyticsInfo?.createAnalyticsEvent, error, selectedMacro?.attrs?.extensionKey);
                }
            }
        }
    };
}
function $e47b9ace59ffb2ab$export$bb0b49ebec872281(selectedMacro, config, macroFilter, extensionAnalyticsInfo, updateMacro, intl, isLivePagesFeatureEnabled) {
    return new Promise(async (resolve, reject)=>{
        const selectedMacroFormattedAsLegacyMacro = await (0, $6mEZ3.formatAsLegacyMacroWithOverrides)(selectedMacro || $e47b9ace59ffb2ab$var$fallbackADNode, intl, isLivePagesFeatureEnabled);
        const macroBrowser = await (0, $7bL1M.loadMacroBrowserResources)();
        // filter based on dynamic data such as feature flags
        if (macroFilter) macroBrowser.metadataList = macroBrowser.metadataList.filter(macroFilter);
        if (extensionAnalyticsInfo) extensionAnalyticsInfo.action = 'update';
        const macroBrowserSettings = await $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, resolve, reject, extensionAnalyticsInfo, undefined, updateMacro);
        try {
            macroBrowser.open({
                ...macroBrowserSettings,
                selectedMacro: {
                    ...selectedMacroFormattedAsLegacyMacro,
                    productContext: {
                        // product context is used by connect macros, when they call /wiki/plugins/servlet/ac/{app-key}/{macro-key}
                        // this endpoint enriches the response's structuredContext field, which is used by AP.context.getContext
                        // ideally would be good to check that this is a connect macro, however, it seems
                        // that there's no information available to check that
                        'content.id': config.contentId,
                        'enrich-content-context-parameters': true
                    }
                }
            });
        } catch (err) {
            $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'openMacroBrowserToEditExistingMacro', extensionAnalyticsInfo?.createAnalyticsEvent, err, selectedMacro?.attrs?.extensionKey);
            reject(err);
        }
    });
}
function $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4(selectedMacro, config, macroFilter, extensionAnalyticsInfo, onCompleteCallback, updateMacro) {
    return new Promise(async (resolve, reject)=>{
        const macroBrowser = await (0, $7bL1M.loadMacroBrowserResources)();
        // filter based on dynamic data such as feature flags
        if (macroFilter) macroBrowser.metadataList = macroBrowser.metadataList.filter(macroFilter);
        if (extensionAnalyticsInfo) extensionAnalyticsInfo.action = 'insert';
        const macroBrowserSettings = await $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, resolve, reject, extensionAnalyticsInfo, onCompleteCallback, updateMacro);
        try {
            macroBrowser.open({
                ...macroBrowserSettings,
                presetMacroMetadata: {
                    ...selectedMacro,
                    productContext: {
                        'content.id': config.contentId,
                        'enrich-content-context-parameters': true
                    }
                }
            });
        } catch (err) {
            $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'openMacroBrowserForInitialConfiguration', extensionAnalyticsInfo?.createAnalyticsEvent, err, selectedMacro?.attrs?.extensionKey);
            reject(err);
        }
    });
}

});
parcelRegister("7bL1M", function(module, exports) {

$parcel$export(module.exports, "loadMacroBrowserResources", () => $eb991ea0881203b1$export$db2ef8ac15563eb4);

var $lwdd5 = parcelRequire("lwdd5");

var $dmKyV = parcelRequire("dmKyV");
const $eb991ea0881203b1$export$1a7a5965be14ecdf = ()=>[
        "wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:editor-resources",
        "wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:create-from-template-macro-browser-resources",
        "wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:create-from-template-resources"
    ];

function $eb991ea0881203b1$export$db2ef8ac15563eb4() {
    return new Promise((resolve)=>{
        const resources = [
            // plugins contributing to macro browser will be loaded through this context.
            // `fabric-editor-macro-browser` context is found in core in case we want to add resources of other macro in future.
            "wrc!fabric-editor-macro-browser",
            // The inline task report plugin implements its own (legacy) way of loading JS overrides, hence we have to require
            // these overrides here.
            "wr!com.atlassian.confluence.plugins.confluence-inline-tasks:inline-tasks-macro-browser",
            // Jira gadgets
            "wr!com.atlassian.confluence.plugins.gadgets:macro-browser-for-gadgetsplugin",
            // these resources are necessary for create-from-template-macro to initialize and populate the template dropdown
            // copy from packages/confluence-editor/src/editor-plugins/create-from-template-macro/plugin.js
            // tinymce also did similar macro loading via packages/confluence-editor/src/editor-plugins/index.js
            ...$eb991ea0881203b1$export$1a7a5965be14ecdf()
        ];
        (0, $dmKyV.WRM).require(resources, ()=>{
            const macroBrowser = (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).require("confluence-macro-browser/macro-browser");
            (parcelRequire("jyZHv")).then((macroBrowserOverridesModule)=>{
                macroBrowserOverridesModule.default();
            }).then(()=>{
                /**
         * this is required for atlassian connect plugin to work correctly
         * e.g open custom dialog for DrawIO, Gliffy macro
         * check this repo for more info:
         * https://stash.atlassian.com/projects/AC/repos/atlassian-connect/browse
         */ // @ts-ignore TODO FIXME we really don't need typings for "window-or-global", we need to get rid of it instead
                (0, (/*@__PURE__*/$parcel$interopDefault($lwdd5))).AJS.trigger("reset.rte");
                resolve(macroBrowser);
            });
        });
    });
}

});
parcelRegister("jyZHv", function(module, exports) {

let $e3e10dc916617261$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e3e10dc916617261$var$load("2wLue").then(()=>parcelRequire('74DtK'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});





parcelRegister("7okiz", function(module, exports) {

$parcel$export(module.exports, "getExtensionHandlers", () => $53f1c3cb11bcb25b$export$fe33197d44e10fcf);

var $gwFzn = parcelRequire("gwFzn");

var $lspPP = parcelRequire("lspPP");

var $k6bGh = parcelRequire("k6bGh");

var $45xzk = parcelRequire("45xzk");

var $jFmKg = parcelRequire("jFmKg");

var $atUCF = parcelRequire("atUCF");

var $9wGTI = parcelRequire("9wGTI");

var $ge2sX = parcelRequire("ge2sX");

var $aJPUt = parcelRequire("aJPUt");

var $5kjCz = parcelRequire("5kjCz");
var $4KFTW = parcelRequire("4KFTW");

var $5PGOG = parcelRequire("5PGOG");

var $fuLIO = parcelRequire("fuLIO");

var $7NX4e = parcelRequire("7NX4e");
var $bQCqI = parcelRequire("bQCqI");

var $8pcS0 = parcelRequire("8pcS0");

var $eS4Za = parcelRequire("eS4Za");

var $hMRhJ = parcelRequire("hMRhJ");

var $l86Zj = parcelRequire("l86Zj");
var $hKeSi = parcelRequire("hKeSi");
var $2LCBF = parcelRequire("2LCBF");
var $6v9Za = parcelRequire("6v9Za");

var $e1Stz = parcelRequire("e1Stz");

var $e8Lxy = parcelRequire("e8Lxy");

var $fBjVq = parcelRequire("fBjVq");

var $lBfIn = parcelRequire("lBfIn");

var $cbr0D = parcelRequire("cbr0D");

var $icKBu = parcelRequire("icKBu");

var $8YuRm = parcelRequire("8YuRm");

var $gvBC9 = parcelRequire("gvBC9");

var $4W2RN = parcelRequire("4W2RN");

var $7zb5a = parcelRequire("7zb5a");
const $53f1c3cb11bcb25b$var$context = {
    insertCss: (styles)=>styles._insertCss()
};
const $53f1c3cb11bcb25b$export$fe33197d44e10fcf = ({ adf: adf, contentId: contentId, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, spaceKey: spaceKey, shouldIncludeMacroHandlers: shouldIncludeMacroHandlers = true, macroRenderedOutput: macroRenderedOutput, shouldIncludeMacroWithReferencesHandlers: shouldIncludeMacroWithReferencesHandlers = false, referentialityDataSourceProvider: referentialityDataSourceProvider, fromFabricEditor: fromFabricEditor = false, isPreviewMode: isPreviewMode = false, contentType: contentType, mediaToken: mediaToken, annotationProvider: annotationProvider, isInEditorRendererView: isInEditorRendererView }, createAnalyticsEvent)=>{
    const getMacroExtensionHandler = $53f1c3cb11bcb25b$export$d1ab742fa63c927c;
    const getTemplateHandler = showTemplateInputInPreview ? (0, $cbr0D.getTemplateVariableInputExtensionHandler) : (0, $cbr0D.getTemplateExtensionHandler);
    const templateHandler = showTemplateVariablesInPreview ? {
        [(0, $8pcS0.EXTENSION_TYPE).TEMPLATE]: getTemplateHandler
    } : {};
    const macroWithReferences = shouldIncludeMacroWithReferencesHandlers ? {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES]: $53f1c3cb11bcb25b$export$97164d5210648f5e({
            adf: adf,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        })
    } : {};
    return shouldIncludeMacroHandlers ? {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: getMacroExtensionHandler({
            adf: adf,
            appearance: appearance,
            contentId: contentId,
            showTemplateVariablesInPreview: showTemplateVariablesInPreview,
            showTemplateInputInPreview: showTemplateInputInPreview,
            spaceKey: spaceKey,
            macroRenderedOutput: macroRenderedOutput,
            referentialityDataSourceProvider: referentialityDataSourceProvider,
            fromFabricEditor: fromFabricEditor,
            isPreviewMode: isPreviewMode,
            contentType: contentType,
            mediaToken: mediaToken,
            annotationProvider: annotationProvider,
            isInEditorRendererView: isInEditorRendererView
        }, createAnalyticsEvent),
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: (0, $bQCqI.getMigrationExtHandlerForRenderer)({
            contentId: contentId,
            contextProviders: {
                ClassicEditorContextProvider: (0, $k6bGh.ClassicEditorContextProviderLazyLoader)
            }
        }),
        ...macroWithReferences,
        ...templateHandler
    } : {};
};
const $53f1c3cb11bcb25b$var$providers = {
    getExtensionHandlers: $53f1c3cb11bcb25b$export$fe33197d44e10fcf,
    EditorLoaderLoader: // CONFCLOUD-72035 - Make sure we are ALWAYS including the EditorLoaderLoader when loading
    //                   legacy macros or else the attachments macro WILL NOT WORK
    $jFmKg.default
};
const $53f1c3cb11bcb25b$export$164cd9171430f0a5 = (isMacroSSRD, macroDefaultProps)=>{
    // if SSR Macros FF is disabled, page is not SSRd, or there are no macros on the page, do nothing
    if (!window.__SSR_RENDERED__ || !window?.__SSR_MACROS_INFO__) return;
    const { extensionKey: extensionKey } = macroDefaultProps;
    if (isMacroSSRD) {
        window.__SSR_MACROS_INFO__.successes[extensionKey] = (window.__SSR_MACROS_INFO__.successes[extensionKey] ?? 0) + 1;
        window.__SSR_MACROS_INFO__.successCount += 1;
    } else {
        window.__SSR_MACROS_INFO__.failures[extensionKey] = (window.__SSR_MACROS_INFO__.failures[extensionKey] ?? 0) + 1;
        window.__SSR_MACROS_INFO__.failureCount += 1;
    }
};
const $53f1c3cb11bcb25b$export$adb86c58ecb79d9c = (macroDefaultProps)=>{
    const { attributes: { macroId: macroId } } = macroDefaultProps;
    return Boolean(window?.__LEGACY_MACRO_RENDERED_OUTPUT__?.find((el)=>el.key === macroId));
};
const $53f1c3cb11bcb25b$export$97164d5210648f5e = ({ adf: adf, referentialityDataSourceProvider: referentialityDataSourceProvider })=>{
    const extensionHandlerWithReferences = (extension, extensionHandler)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4W2RN.MacroReference), {
            adf: adf,
            extensionParams: extension,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        }, extensionHandler);
    };
    return extensionHandlerWithReferences;
};
const $53f1c3cb11bcb25b$export$d1ab742fa63c927c = ({ adf: adf, contentId: contentId, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, spaceKey: spaceKey, macroRenderedOutput: macroRenderedOutput, referentialityDataSourceProvider: referentialityDataSourceProvider, fromFabricEditor: fromFabricEditor, isPreviewMode: isPreviewMode, mediaToken: mediaToken, annotationProvider: annotationProvider, isInEditorRendererView: isInEditorRendererView }, createAnalyticsEvent)=>(0, $eS4Za.createMacroExtensionHandler)((extension, doc)=>{
        const { extensionKey: extensionKey } = extension;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const macroParams = extension?.parameters?.macroParams;
        const multiBodiedExtensionActions = doc?.[0]?.actions;
        const isBodiedMacro = extension?.type === 'bodiedExtension';
        const shouldUseDebouncedLegacyMacroRenderer = isBodiedMacro && isInEditorRendererView;
        // When isInEditorRendererView is true, we are rendering the macro in the editor renderer view.
        // In this scenario adf isn't passed to the macro extension handler as prop because we do not have access to
        // the adf from where we are using the macro extension handler. We can instead get the adf from the doc object provided to the handler.
        adf = isInEditorRendererView && !adf && !!doc ? doc?.[0] : adf;
        const attributesForAnalytics = {
            extensionType: extension?.type,
            ...extensionKey === 'excerpt-include' ? {
                isExcerptNamePresent: !!macroParams?.name
            } : undefined,
            ...extensionKey === 'gadget' && macroParams?.url?.value && {
                gadgetUrl: new URL(macroParams.url.value, location.origin).pathname
            }
        };
        const redactedAttributes = extensionKey === 'redactedMacroPlaceholder' ? {
            extensionKey: macroParams?.redactedMacroPluginKey?.value || macroParams?.redactedMacroExtensionKey?.value
        } : undefined;
        const isMissingMacroParameters = macroParams?.isMissingRequiredParameters?.value;
        const contentHandler = (macroDefaultProps, cloudId, userId)=>{
            const excerptMacroProps = {
                ...macroDefaultProps,
                appearance: appearance
            };
            const macroOutput = extension?.parameters?.macroOutput;
            if (extensionKey === 'toc' && macroParams && createAnalyticsEvent) (0, $7zb5a.sendTrackingEvent)(extensionKey, macroParams, createAnalyticsEvent, contentId);
            const legacyMacroRenderer = ()=>{
                const isMacroSSRD = window.__SSR_RENDERED__ && $53f1c3cb11bcb25b$export$adb86c58ecb79d9c(macroDefaultProps) && !isMissingMacroParameters;
                $53f1c3cb11bcb25b$export$164cd9171430f0a5(isMacroSSRD, macroDefaultProps);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
                    value: $53f1c3cb11bcb25b$var$providers
                }, shouldUseDebouncedLegacyMacroRenderer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fuLIO.DebouncedLegacyMacroRendererQuery), {
                    ...macroDefaultProps,
                    isTemplateEditorRenderer: showTemplateVariablesInPreview,
                    macroRenderedOutputFromSSR: isMacroSSRD && macroRenderedOutput,
                    macroOutput: macroOutput,
                    isPreviewMode: isPreviewMode,
                    isInEditorRendererView: isInEditorRendererView
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fuLIO.LegacyMacroRendererQuery), {
                    ...macroDefaultProps,
                    isTemplateEditorRenderer: showTemplateVariablesInPreview,
                    macroRenderedOutputFromSSR: isMacroSSRD && macroRenderedOutput,
                    macroOutput: macroOutput,
                    isPreviewMode: isPreviewMode
                }));
            };
            switch(extensionKey){
                case 'redactedMacroPlaceholder':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $atUCF.RedactedPlaceholderExtensionHandler), {
                        ...macroDefaultProps,
                        redactedAttributes: redactedAttributes
                    });
                case 'details':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hKeSi.DetailsExtensionHandler), {
                        ...macroDefaultProps,
                        spaceKey: spaceKey,
                        Renderer: (0, $fBjVq.default),
                        isLegacyRenderer: true,
                        annotationProvider: annotationProvider
                    });
                case 'excerpt':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2LCBF.ExcerptExtensionHandler), {
                        ...excerptMacroProps,
                        spaceKey: spaceKey,
                        Renderer: (0, $fBjVq.default),
                        isLegacyRenderer: true,
                        mediaToken: mediaToken,
                        annotationProvider: annotationProvider
                    });
                case 'expand':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6v9Za.ExpandExtensionHandler), {
                        ...macroDefaultProps,
                        Renderer: (0, $fBjVq.default),
                        annotationProvider: annotationProvider,
                        isLegacyRenderer: true
                    });
                case 'create-from-template':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $icKBu.CreateFromTemplateHandler), {
                        hasADF: !!adf,
                        macroDefaultProps: macroDefaultProps,
                        cloudId: cloudId,
                        userId: userId,
                        isPreviewMode: isPreviewMode,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'toc':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gvBC9.TableOfContentsHandler), {
                        adf: adf,
                        macroDefaultProps: macroDefaultProps,
                        cloudId: cloudId,
                        userId: userId,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'livesearch':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8YuRm.LiveSearchHandler), {
                        hasADF: !!adf,
                        macroDefaultProps: macroDefaultProps,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'anchor':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l86Zj.AnchorExtensionHandler), {
                        ...macroDefaultProps,
                        isSSR: false
                    });
                case 'excerpt-include':
                    if (contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $45xzk.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7NX4e.ExcerptIncludeExtensionHandler), {
                        ...macroDefaultProps,
                        Renderer: (0, $e8Lxy.PageContentRenderer)
                    }));
                case 'detailssummary':
                    return (0, $9wGTI.fg)('confluence_ppr_adf_rendering') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $45xzk.ClassicEditorContextProviderLoader), {
                        isWithinEditor: false
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e1Stz.PagePropertiesReportRenderer), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: macroParams
                    })) : legacyMacroRenderer();
                case 'profile-picture':
                    return (0, $5PGOG.isProfileMacrosExperimentEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5PGOG.ProfilePictureMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    }) : legacyMacroRenderer();
                case 'profile':
                    return (0, $5PGOG.isProfileMacrosExperimentEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5PGOG.UserProfileMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    }) : legacyMacroRenderer();
                // generic macro renderer
                default:
                    return legacyMacroRenderer();
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4W2RN.MacroReference), {
            adf: adf,
            extensionParams: extension,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        }, ({ references: references })=>{
            const macroDefaultProps = {
                node: extension,
                references: references,
                contentId: contentId,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview || false,
                showTemplateInputInPreview: showTemplateInputInPreview || false,
                spaceKey: spaceKey || '',
                mode: (0, $5kjCz.RENDERER),
                context: $53f1c3cb11bcb25b$var$context,
                extensionKey: extensionKey,
                attributes: attributes,
                multiBodiedExtensionActions: multiBodiedExtensionActions
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KFTW.MacroExperienceStart), {
                contentId: contentId,
                name: (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension),
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes,
                timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lBfIn.MacroAnalyticsWrapper), {
                extensionKey: extensionKey,
                attributes: {
                    ...attributesForAnalytics,
                    ...redactedAttributes
                },
                node: extension
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ge2sX.SessionData), null, ({ cloudId: cloudId, userId: userId })=>contentHandler(macroDefaultProps, cloudId, userId))));
        }));
    });

});
parcelRegister("k6bGh", function(module, exports) {

$parcel$export(module.exports, "ClassicEditorContextProviderLazyLoader", () => $6ba7b2a55cef73d6$export$5fc4d24c17f7a720);

var $jmjWc = parcelRequire("jmjWc");

const $6ba7b2a55cef73d6$export$5fc4d24c17f7a720 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "yWY-m",
    name: 'ClassicEditorContextProviderLazyLoader',
    loader: ()=>(parcelRequire("1GHZ9"))
});

});
parcelRegister("1GHZ9", function(module, exports) {

let $13abd5412f6659d5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $13abd5412f6659d5$var$load("cRUrz"),
    $13abd5412f6659d5$var$load("8Xlsv"),
    $13abd5412f6659d5$var$load("hY7D1"),
    $13abd5412f6659d5$var$load("iHZci"),
    $13abd5412f6659d5$var$load("dZKCL"),
    $13abd5412f6659d5$var$load("8rpJ0"),
    $13abd5412f6659d5$var$load("cHp04"),
    $13abd5412f6659d5$var$load("gkmZg"),
    $13abd5412f6659d5$var$load("jQFGH"),
    $13abd5412f6659d5$var$load("fQ1rW"),
    $13abd5412f6659d5$var$load("dBM33"),
    $13abd5412f6659d5$var$load("2YKx2"),
    $13abd5412f6659d5$var$load("5tHTv"),
    $13abd5412f6659d5$var$load("ahb4M"),
    $13abd5412f6659d5$var$load("1MwaY"),
    $13abd5412f6659d5$var$load("cNnZR"),
    $13abd5412f6659d5$var$load("dQVTa"),
    $13abd5412f6659d5$var$load("mltxm"),
    $13abd5412f6659d5$var$load("7X74w"),
    $13abd5412f6659d5$var$load("4ru9N"),
    $13abd5412f6659d5$var$load("h4Nf7"),
    $13abd5412f6659d5$var$load("fYcvL"),
    $13abd5412f6659d5$var$load("avfAy"),
    $13abd5412f6659d5$var$load("l9Ahd"),
    $13abd5412f6659d5$var$load("ebtUB"),
    $13abd5412f6659d5$var$load("gYdbF"),
    $13abd5412f6659d5$var$load("5pCOW"),
    $13abd5412f6659d5$var$load("b1HbL"),
    $13abd5412f6659d5$var$load("idfnC"),
    $13abd5412f6659d5$var$load("7D2ux"),
    $13abd5412f6659d5$var$load("aXsk5"),
    $13abd5412f6659d5$var$load("fZNCx")
]).then(()=>parcelRequire('aVsFY'));

});


parcelRegister("jFmKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5137d66f48adfc6$export$2e2bcd8739ae039);
parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

const $e5137d66f48adfc6$var$EditorLoaderLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8A3gW",
    name: "EditorLoaderLoader",
    loader: ()=>(parcelRequire("6X3LR"))
});
var $e5137d66f48adfc6$export$2e2bcd8739ae039 = $e5137d66f48adfc6$var$EditorLoaderLoader;

});
parcelRegister("6X3LR", function(module, exports) {

let $50fb2d98d871db4c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $50fb2d98d871db4c$var$load("43hsF"),
    $50fb2d98d871db4c$var$load("i27dG")
]).then(()=>parcelRequire('8EC29'));

});


parcelRegister("atUCF", function(module, exports) {

$parcel$export(module.exports, "RedactedPlaceholderExtensionHandler", () => $93c4a623cfe89294$export$8b14718323f670aa);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $aR2Yx = parcelRequire("aR2Yx");

const $93c4a623cfe89294$export$8b14718323f670aa = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "QOMzx",
    name: "RedactedPlaceholderExtensionHandler",
    loader: async ()=>{
        const { RedactedPlaceholder: RedactedPlaceholder } = await (parcelRequire("fspUs"));
        return RedactedPlaceholder;
    },
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aR2Yx.RedactedPlaceholderComponentShadow), null)
});

});
parcelRegister("aR2Yx", function(module, exports) {

$parcel$export(module.exports, "RedactedPlaceholderComponentShadow", () => $a3bfb2f361b9631e$export$e34f51b2cfaca368);
const $a3bfb2f361b9631e$export$e34f51b2cfaca368 = ()=>null;

});

parcelRegister("fspUs", function(module, exports) {

let $b40d919f8a6b7746$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b40d919f8a6b7746$var$load("dQy5b").then(()=>parcelRequire('fcgkZ'));

});


parcelRegister("bQCqI", function(module, exports) {

$parcel$export(module.exports, "getMigrationExtHandlerForRenderer", () => $1e9e777543fb9510$export$112339158948d5ae);

var $gwFzn = parcelRequire("gwFzn");

var $lspPP = parcelRequire("lspPP");

var $eS4Za = parcelRequire("eS4Za");

var $8pcS0 = parcelRequire("8pcS0");

var $5kjCz = parcelRequire("5kjCz");
var $4KFTW = parcelRequire("4KFTW");

var $aJPUt = parcelRequire("aJPUt");

var $7y0YZ = parcelRequire("7y0YZ");

var $fVX1M = parcelRequire("fVX1M");

var $6842f = parcelRequire("6842f");
const $1e9e777543fb9510$export$112339158948d5ae = ({ contentId: contentId, contextProviders: contextProviders })=>(0, $eS4Za.createMacroExtensionHandler)((extension)=>{
        if (!extension) return null;
        const { extensionKey: extensionKey, parameters: parameters } = extension;
        const { ClassicEditorContextProvider: ClassicEditorContextProvider = ({ children: children })=>children } = contextProviders;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const defaultProps = {
            contentId: contentId,
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey,
            attributes: attributes,
            node: extension
        };
        let implementation;
        switch(extensionKey){
            case (0, $8pcS0.EXTENSION_KEY).INVALID:
                // extension is rendered outside of React DOM tree and require access to the ClassicEditorContext
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(ClassicEditorContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7y0YZ.InvalidExtensionLoader), {
                    parameters: parameters,
                    ...defaultProps
                }));
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE:
                const inlineExternalImageProps = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fVX1M.InlineExternalImage), {
                    ...inlineExternalImageProps,
                    ...defaultProps
                });
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE:
                const inlineMediaImageProps = parameters;
                const { link: link } = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6842f.InlineImage), {
                    ...inlineMediaImageProps,
                    ...defaultProps,
                    link: link
                });
                break;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension),
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey,
            attributes: attributes,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
            contentId: contentId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lspPP.RendererActionsContext), null, implementation));
    });

});

parcelRegister("lBfIn", function(module, exports) {

$parcel$export(module.exports, "MacroAnalyticsWrapper", () => $4f09d12458901289$export$9eec8c53e410de67);

var $gwFzn = parcelRequire("gwFzn");

var $1DWH0 = parcelRequire("1DWH0");

var $78QFu = parcelRequire("78QFu");

var $2E7zk = parcelRequire("2E7zk");
const $4f09d12458901289$export$9eec8c53e410de67 = (0, $1DWH0.default)()(class extends (0, $gwFzn.Component) {
    async componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent, extensionKey: extensionKey, attributes: attributes, node: node } = this.props;
        if (createAnalyticsEvent) {
            const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(extensionKey, node?.parameters?.macroParams?.serverId?.value, true);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "viewed",
                    actionSubject: "macro",
                    actionSubjectId: extensionKey,
                    source: "viewPageScreen",
                    attributes: {
                        ...attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                        jiraHostingOption: jiraHostingOption
                    }
                }
            }).fire();
        }
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    }
});

});

parcelRegister("cbr0D", function(module, exports) {

$parcel$export(module.exports, "getTemplateExtensionHandler", () => $aaaff26cb260a96a$export$fb67b4c81279b22e);
$parcel$export(module.exports, "getTemplateVariableInputExtensionHandler", () => $aaaff26cb260a96a$export$14d3630cd94f43d4);

var $gwFzn = parcelRequire("gwFzn");

var $8pcS0 = parcelRequire("8pcS0");

var $3JqyB = parcelRequire("3JqyB");
var $2igSQ = parcelRequire("2igSQ");
const $aaaff26cb260a96a$export$fb67b4c81279b22e = (extension)=>{
    if (!extension) return null;
    const { extensionKey: extensionKey, parameters: parameters } = extension;
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).TEMPLATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3JqyB.TemplateVariableComponent), {
        parameters: parameters
    });
    return null;
};
const $aaaff26cb260a96a$export$14d3630cd94f43d4 = (extension)=>{
    if (!extension) return null;
    const { extensionKey: extensionKey, parameters: parameters } = extension;
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).TEMPLATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2igSQ.TemplateVariableInput), {
        parameters: parameters
    });
    return null;
};

});
parcelRegister("3JqyB", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableComponent", () => $f366aa2b03faa65b$export$3e35a8e6e9fd352d);

var $gwFzn = parcelRequire("gwFzn");

var $kwjRd = parcelRequire("kwjRd");
const $f366aa2b03faa65b$export$3e35a8e6e9fd352d = ({ parameters: parameters })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableNameWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableName), {
        "data-testid": "variable-name"
    }, parameters?.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwjRd.TemplateVariableType), {
        "data-testid": "variable-type"
    }, `| ${parameters?.type}`));
};

});


parcelRegister("icKBu", function(module, exports) {

$parcel$export(module.exports, "CreateFromTemplateHandler", () => $f19eca96759725e5$export$30c773822372f598);

var $gwFzn = parcelRequire("gwFzn");

var $fuLIO = parcelRequire("fuLIO");

var $cYJC5 = parcelRequire("cYJC5");
const $f19eca96759725e5$export$30c773822372f598 = ({ hasADF: hasADF, macroDefaultProps: macroDefaultProps, cloudId: cloudId, userId: userId, isPreviewMode: isPreviewMode, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    if (!hasADF) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    return shouldLoadAfterPaint || isPreviewMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cYJC5.LazyCreateFromTemplateLoader), {
        userId: userId,
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps,
        isPreviewMode: isPreviewMode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cYJC5.CreateFromTemplateLoader), {
        userId: userId,
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps,
        isPreviewMode: isPreviewMode
    });
};

});

parcelRegister("8YuRm", function(module, exports) {

$parcel$export(module.exports, "LiveSearchHandler", () => $1fa3854e066af442$export$e8ac5007ab7a695a);

var $gwFzn = parcelRequire("gwFzn");

var $fuLIO = parcelRequire("fuLIO");

var $6mEZ3 = parcelRequire("6mEZ3");

var $l7BGZ = parcelRequire("l7BGZ");
const $1fa3854e066af442$export$e8ac5007ab7a695a = ({ hasADF: hasADF, macroDefaultProps: macroDefaultProps, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    // Fallback to LegacyMacroRenderer when adf string is not defined
    if (!hasADF) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    const { node: node } = macroDefaultProps;
    const macroNode = (0, $6mEZ3.extensionToADF)(node);
    return shouldLoadAfterPaint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l7BGZ.LazyLiveSearchLoader), {
        macroNode: macroNode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $l7BGZ.LiveSearchLoader), {
        macroNode: macroNode
    });
};

});

parcelRegister("gvBC9", function(module, exports) {

$parcel$export(module.exports, "TableOfContentsHandler", () => $ab0c2ef401baeb08$export$cf1c26fcb7e6ff9f);

var $gwFzn = parcelRequire("gwFzn");

var $fuLIO = parcelRequire("fuLIO");

var $dwS6P = parcelRequire("dwS6P");
const $ab0c2ef401baeb08$export$cf1c26fcb7e6ff9f = ({ adf: adf, macroDefaultProps: macroDefaultProps, cloudId: cloudId, userId: userId, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    if (!adf) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    return shouldLoadAfterPaint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dwS6P.LazyTableOfContentsLoader), {
        userId: userId,
        cloudId: cloudId,
        adf: adf,
        macroDefaultProps: macroDefaultProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dwS6P.TableOfContentsLoader), {
        userId: userId,
        cloudId: cloudId,
        adf: adf,
        macroDefaultProps: macroDefaultProps
    });
};

});

parcelRegister("4W2RN", function(module, exports) {

$parcel$export(module.exports, "MacroReference", () => $3bd71c84d7d120d2$export$c25b654b62d7c7b4);

var $csnse = parcelRequire("csnse");

var $dx8CK = parcelRequire("dx8CK");
const $3bd71c84d7d120d2$var$memoAdfParsed = (0, $csnse.default)((adf)=>{
    let result = adf;
    if (typeof adf === "string") try {
        result = JSON.parse(adf);
    } catch (e) {
        result = {
            version: 1,
            type: 'doc',
            content: []
        };
    }
    return result;
});
const $3bd71c84d7d120d2$export$c25b654b62d7c7b4 = ({ adf: adf, extensionParams: extensionParams, referentialityDataSourceProvider: referentialityDataSourceProvider, children: children })=>{
    const adfParsed = $3bd71c84d7d120d2$var$memoAdfParsed(adf);
    const { references: references } = (0, $dx8CK.useReference)({
        adf: adfParsed,
        extensionParams: extensionParams,
        dataSourceProvider: referentialityDataSourceProvider
    });
    return children({
        references: references
    });
};

});

parcelRegister("7zb5a", function(module, exports) {

$parcel$export(module.exports, "sendTrackingEvent", () => $27d039b331e27185$export$b7595b0733376572);
var $27d039b331e27185$var$Styles = /*#__PURE__*/ function(Styles) {
    Styles["None"] = "none";
    Styles["Mixed"] = "mixed";
    Styles["Bullet"] = "bullet";
    Styles["Circle"] = "circle";
    Styles["Square"] = "square";
    Styles["Number"] = "number";
    return Styles;
}($27d039b331e27185$var$Styles || {});
var $27d039b331e27185$var$Separators = /*#__PURE__*/ function(Separators) {
    Separators["Brackets"] = "brackets";
    Separators["Braces"] = "braces";
    Separators["Pipe"] = "pipe";
    return Separators;
}($27d039b331e27185$var$Separators || {});
const $27d039b331e27185$export$b7595b0733376572 = (macroName, trackingData, createAnalyticsEvent, contentId)=>{
    const { minLevel: minLevel, maxLevel: maxLevel, outline: outline, type: type, printable: printable, style: style, separator: separator, include: include, exclude: exclude, indent: indent } = trackingData;
    const sensitiveData = {
        include: include?.value.length > 0 || false,
        exclude: exclude?.value.length > 0 || false,
        class: trackingData.class?.value.length > 0 || false,
        indent: indent?.value.length > 0 || false
    };
    // in the unlikely event these dropdown fields become custom input text, ensure no PII is logged
    const separatorValue = Object.values($27d039b331e27185$var$Separators).includes(separator?.value) ? separator?.value : 'invalid';
    const styleValue = Object.values($27d039b331e27185$var$Styles).includes(style?.value) ? style?.value : 'invalid';
    const potentiallySensitiveData = {};
    if (type) {
        if (type.value === 'flat') potentiallySensitiveData['separator'] = separatorValue;
        else if (type.value === 'list') potentiallySensitiveData['style'] = styleValue;
    } else potentiallySensitiveData['style'] = 'mixed';
    const nonSensitiveData = {
        minLevel: parseInt(minLevel?.value) || 1,
        maxLevel: parseInt(maxLevel?.value) || 6,
        outline: outline?.value === 'true' || false,
        printable: printable?.value === 'false' || true,
        type: type?.value === "flat" ? "flat" : "list"
    };
    createAnalyticsEvent({
        type: "sendTrackEvent",
        data: {
            action: "viewed",
            actionSubject: "macro",
            actionSubjectId: macroName,
            source: "on page view",
            attributes: {
                pageID: contentId,
                ...sensitiveData,
                ...potentiallySensitiveData,
                ...nonSensitiveData
            },
            eventType: "track"
        }
    }).fire();
};

});


parcelRegister("69aHU", function(module, exports) {

$parcel$export(module.exports, "populateExtensionProviders", () => $2d9ea9a54c5e94d8$export$c0ba9eb7d0e2ed47);

var $eEmxu = parcelRequire("eEmxu");
var $bre0g = parcelRequire("bre0g");

var $5bak6 = parcelRequire("5bak6");

var $gKr8t = parcelRequire("gKr8t");

var $bfil7 = parcelRequire("bfil7");

var $8pcS0 = parcelRequire("8pcS0");

var $04e9M = parcelRequire("04e9M");

var $aIqlA = parcelRequire("aIqlA");

var $8z3oB = parcelRequire("8z3oB");
var $aF5bm = parcelRequire("aF5bm");

var $gxXVf = parcelRequire("gxXVf");

var $6y6Gt = parcelRequire("6y6Gt");

var $bgcaM = parcelRequire("bgcaM");

const $2d9ea9a54c5e94d8$var$createLCMRendererExtensionProvider = async ()=>{
    const { rendererManifest: rendererManifest } = await (parcelRequire("krPyM"));
    return new (0, $bre0g.default)([
        rendererManifest
    ]);
};
const $2d9ea9a54c5e94d8$export$c0ba9eb7d0e2ed47 = (providerFactory, { intl: intl, containerId: containerId, accountId: accountId, cloudId: cloudId, spaceKey: spaceKey, spaceId: spaceId, contentId: contentId, contentType: contentType, environment: environment, extensionHandlers: extensionHandlers, showTemplateInputInPreview: showTemplateInputInPreview, showTemplateVariablesInPreview: showTemplateVariablesInPreview, setManifestReadyState: setManifestReadyState, createAnalyticsEvent: createAnalyticsEvent, activationId: activationId, isLivePage: isLivePage = false, isLivePagesFeatureEnabled: isLivePagesFeatureEnabled = false })=>{
    const extensionProvidersList = [];
    const extensionProvider = (0, $bfil7.getConfluenceMacrosExtensionProviderForRenderer)({
        contentId: contentId,
        spaceKey: spaceKey,
        spaceId: spaceId,
        features: {}
    }, extensionHandlers, (0, $bgcaM.getMigrationExtensionManifest), (0, $gxXVf.openMacroBrowserToEditExistingMacro), (0, $gxXVf.openMacroBrowserForInitialConfiguration), intl, createAnalyticsEvent, providerFactory, isLivePagesFeatureEnabled);
    extensionProvidersList.push(extensionProvider);
    const lcmExtension = $2d9ea9a54c5e94d8$var$createLCMRendererExtensionProvider();
    extensionProvidersList.push(lcmExtension);
    if (showTemplateInputInPreview || showTemplateVariablesInPreview) extensionProvidersList.push(new (0, $bre0g.default)([
        (0, $6y6Gt.getTemplateVariableExtensionManifest)(intl, showTemplateInputInPreview ? (0, $6y6Gt.TemplateVariableMode).INPUT : (0, $6y6Gt.TemplateVariableMode).CONFIG)
    ]));
    const apolloClient = (0, $gKr8t.getAGGClient)();
    const contextIds = [
        (0, $aF5bm.getWorkspaceARI)({
            cloudId: cloudId,
            activationId: activationId
        })
    ];
    const forgeExtensionProvider = async ()=>{
        const getProviderOptions = ({ spaceKey: spaceKeyArg })=>({
                accountId: accountId ?? undefined,
                cloudId: cloudId,
                apolloClient: apolloClient,
                contextIds: contextIds,
                dataProviders: providerFactory,
                environment: (0, $5bak6.environmentToForgeProductEnvironment)(environment),
                product: 'confluence',
                page: 'confluence:macroRenderer',
                isEditing: false,
                analyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
                forgeUIAnalyticsContext: (0, $5bak6.createForgeUIAnalyticsContext)({
                    objectId: contentId,
                    // @ts-ignore
                    objectType: contentType,
                    containerId: containerId,
                    containerType: 'space'
                }),
                extensionData: (0, $5bak6.createForgeMacroExtensionData)({
                    spaceKey: spaceKeyArg ?? '',
                    isLivePage: isLivePage,
                    spaceId: spaceId ?? '',
                    contentId: contentId,
                    contentType: contentType
                }),
                extensionHandlerWithReference: extensionHandlers[(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES],
                connectExtensionProvider: extensionProvider,
                FlagProvider: $8z3oB.FlagProvider,
                extensionsFilter: undefined,
                locale: intl.locale
            });
        return (0, $aIqlA.fetchForgeExtensionProvider)({
            getProviderOptions: getProviderOptions,
            spaceKey: spaceKey
        });
    };
    extensionProvidersList.push(forgeExtensionProvider());
    if (extensionProvidersList.length > 0) providerFactory.setProvider('extensionProvider', Promise.resolve((0, $eEmxu.default)(extensionProvidersList)));
    // Make sure we set mainfestReadyState always
    Promise.all(extensionProvidersList).then(()=>{
        setManifestReadyState?.(true);
    });
};

});
parcelRegister("6y6Gt", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableMode", () => $399836d35d211a20$export$f73f87f0b8cabb66);
$parcel$export(module.exports, "getTemplateVariableExtensionManifest", () => $399836d35d211a20$export$de09af8432d39de0);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $eIlE7 = parcelRequire("eIlE7");

var $3JqyB = parcelRequire("3JqyB");
var $2igSQ = parcelRequire("2igSQ");

var $8pcS0 = parcelRequire("8pcS0");

var $2oer2 = parcelRequire("2oer2");
var $399836d35d211a20$export$f73f87f0b8cabb66 = /*#__PURE__*/ function(TemplateVariableMode) {
    TemplateVariableMode[TemplateVariableMode["CONFIG"] = 0] = "CONFIG";
    TemplateVariableMode[TemplateVariableMode["INPUT"] = 1] = "INPUT";
    return TemplateVariableMode;
}({});
const $399836d35d211a20$var$i18n = (0, $2nPZH.defineMessages)({
    templateVariablesAdd: {
        id: "confluence-fabric-editor.template.variables.add",
        defaultMessage: "New variable"
    },
    templateVariablesAddTooltip: {
        id: "confluence-fabric-editor.template.variables.add.tooltip",
        defaultMessage: "Add a new field into the page for the template user to fill out."
    }
});
function $399836d35d211a20$export$de09af8432d39de0(intl, mode = 0, config, editorActions) {
    const type = 'inlineExtension';
    const title = intl.formatMessage($399836d35d211a20$var$i18n.templateVariablesAdd);
    const Component = mode === 1 ? (0, $2igSQ.TemplateVariableInput) : (0, $3JqyB.TemplateVariableComponent);
    return {
        key: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
        type: (0, $8pcS0.EXTENSION_TYPE).TEMPLATE,
        title: title,
        description: intl.formatMessage($399836d35d211a20$var$i18n.templateVariablesAddTooltip),
        icons: {
            '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))), {
                        color: "currentColor",
                        label: title,
                        spacing: "spacious"
                    })
        },
        modules: {
            quickInsert: editorActions && [
                {
                    key: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
                    featured: true,
                    action: {
                        type: 'node',
                        key: 'default',
                        parameters: {
                            type: (0, $2oer2.TEXT_TYPE),
                            name: (0, $2oer2.defaultVariableName)
                        }
                    }
                }
            ],
            nodes: {
                default: {
                    type: type,
                    render: async ()=>({ node: node })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
                                parameters: node.parameters
                            }),
                    update: config && (async (parameters)=>{
                        try {
                            const { attrs: attrs } = await (0, $2oer2.openTemplateVariableDialog)({
                                type: type,
                                attrs: {
                                    parameters: parameters
                                }
                            }, config);
                            return attrs.parameters || parameters;
                        } catch  {
                            // On error keep the existing value
                            return parameters;
                        }
                    })
                }
            }
        }
    };
}

});
parcelRegister("2oer2", function(module, exports) {

$parcel$export(module.exports, "TEXT_TYPE", () => $653189039caa12b3$export$ae3b897442224943);
$parcel$export(module.exports, "defaultVariableName", () => $653189039caa12b3$export$178c63c1bbc65458);
$parcel$export(module.exports, "openTemplateVariableDialog", () => $653189039caa12b3$export$9d5f42c8c61fd9fc);

var $iol5P = parcelRequire("iol5P");

var $j2dS3 = parcelRequire("j2dS3");

var $8pcS0 = parcelRequire("8pcS0");

var $cbr0D = parcelRequire("cbr0D");
const $653189039caa12b3$export$ae3b897442224943 = "text";
const $653189039caa12b3$export$a43e313f04be91d7 = "textarea";
const $653189039caa12b3$export$22c50a44ec8aa5dd = "select";
const $653189039caa12b3$export$178c63c1bbc65458 = "variable_name";
function $653189039caa12b3$export$166100f9abd52166(name = $653189039caa12b3$export$178c63c1bbc65458) {
    return {
        type: (0, $8pcS0.INLINE_EXTENSION_TYPE),
        attrs: {
            extensionType: (0, $8pcS0.EXTENSION_TYPE).TEMPLATE,
            extensionKey: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
            parameters: {
                type: $653189039caa12b3$export$ae3b897442224943,
                name: name
            }
        }
    };
}
function $653189039caa12b3$export$fd5152d3cbf54f5f(node) {
    return node.attrs && node.attrs.extensionType === (0, $8pcS0.EXTENSION_TYPE).TEMPLATE;
}
function $653189039caa12b3$export$9d5f42c8c61fd9fc(selectedNode, config) {
    return new Promise((resolve, reject)=>{
        if (!selectedNode.attrs || !config.setActiveModal) {
            reject(new Error("Cannot open editing template variable dialog"));
            return;
        }
        const params = selectedNode.attrs.parameters;
        config.setActiveModal((0, $iol5P.TemplateVariableDialogLoader), {
            defaultVariableType: params.type,
            defaultVariableName: params.name,
            defaultRows: params.params && params.params.rows,
            defaultColumns: params.params && params.params.columns,
            defaultListOptions: params.params && params.params.options,
            onSave: (updatedParams)=>{
                const adf = (0, $j2dS3.updateParams)(selectedNode, updatedParams);
                // MacroAttributes and ADNode are pretty much the same type, but
                // MacroAttributes requires either "extension", "bodiedExtension", or
                // "inlineExtension". This check is so we can pass the ADNode as a
                // MacroAttributes, but will default to "extension" if given an
                // unexpected value.
                let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
                if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) extensionType = (0, $8pcS0.BODIED_EXTENSION_TYPE);
                else if (adf.type === (0, $8pcS0.INLINE_EXTENSION_TYPE)) extensionType = (0, $8pcS0.INLINE_EXTENSION_TYPE);
                resolve({
                    ...adf,
                    type: extensionType,
                    attrs: adf.attrs || {}
                });
            },
            onClose: ()=>{
                if (config.closeActiveModal) config.closeActiveModal();
            }
        });
    });
}

});
parcelRegister("iol5P", function(module, exports) {

$parcel$export(module.exports, "TemplateVariableDialogLoader", () => $2957f690f8f5a888$export$4072164b6bd9337);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $lOkIA = parcelRequire("lOkIA");

const $2957f690f8f5a888$export$4072164b6bd9337 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "FUMAJ",
    name: "TemplateVariableDialogLoader",
    loader: async ()=>(await (parcelRequire("d5SJI"))).TemplateVariableDialogComponent,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium"
        })
});

});
parcelRegister("d5SJI", function(module, exports) {

let $988633801f46cd7a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $988633801f46cd7a$var$load("6IjKj").then(()=>parcelRequire('5KoaE'));

});


parcelRegister("j2dS3", function(module, exports) {

$parcel$export(module.exports, "updateParams", () => $a9c66c4a525522c3$export$8198c5b4e81b9082);
$parcel$export(module.exports, "filterADNodesByType", () => $a9c66c4a525522c3$export$676214b4858262c1);
function $a9c66c4a525522c3$export$e2b5c5db9e2009fd(node) {
    return node.type.name || node.type;
}
function $a9c66c4a525522c3$export$8198c5b4e81b9082(node, newParams) {
    return {
        type: $a9c66c4a525522c3$export$e2b5c5db9e2009fd(node),
        attrs: {
            ...node.attrs,
            parameters: {
                ...node.attrs.parameters,
                ...newParams
            }
        }
    };
}
function $a9c66c4a525522c3$export$d1c50812de760a07(root, callbackFunc) {
    for (const nodeKey of Object.keys(root)){
        const nodeValue = root[nodeKey];
        callbackFunc(nodeKey, nodeValue);
        // go deeper
        if (nodeValue !== null && typeof nodeValue === "object") $a9c66c4a525522c3$export$d1c50812de760a07(root[nodeKey], callbackFunc);
    }
}
function $a9c66c4a525522c3$export$676214b4858262c1(root, typeName) {
    const results = [];
    $a9c66c4a525522c3$export$d1c50812de760a07(root, (_nodeKey, nodeValue)=>{
        if (nodeValue && nodeValue.type === typeName) results.push(nodeValue);
    });
    return results;
}

});



parcelRegister("bgcaM", function(module, exports) {

$parcel$export(module.exports, "getMigrationExtensionManifest", () => $bc16cbc3cc94b402$export$fb67662ebef720ab);

var $gwFzn = parcelRequire("gwFzn");

var $jdPfT = parcelRequire("jdPfT");

var $8pcS0 = parcelRequire("8pcS0");

var $5h7sn = parcelRequire("5h7sn");
var $bQCqI = parcelRequire("bQCqI");
var $cpwiw = parcelRequire("cpwiw");

var $k6bGh = parcelRequire("k6bGh");
function $bc16cbc3cc94b402$export$fb67662ebef720ab(contentId, isEditor, flags, createAnalyticsEvent) {
    const type = 'inlineExtension';
    const getExtensionHandler = isEditor ? (0, $5h7sn.getMigrationExtHandlerForEditor) : (0, $bQCqI.getMigrationExtHandlerForRenderer);
    return [
        (0, $8pcS0.EXTENSION_KEY).INVALID,
        (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE,
        (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE
    ].map((key)=>({
            title: 'Migration Extension',
            key: key,
            type: (0, $8pcS0.EXTENSION_TYPE).MIGRATION,
            icons: {
                '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                            label: "Migration Extension"
                        })
            },
            modules: {
                nodes: {
                    default: {
                        type: type,
                        render: async ()=>({ node: node })=>getExtensionHandler({
                                    contentId: contentId,
                                    contextProviders: {
                                        ClassicEditorContextProvider: (0, $k6bGh.ClassicEditorContextProviderLazyLoader)
                                    }
                                })(node, {}),
                        update: isEditor ? (parameters)=>(0, $cpwiw.showUnmodifiableMacroFlag)({
                                type: type,
                                attrs: {
                                    parameters: parameters
                                }
                            }, flags, createAnalyticsEvent) : undefined
                    }
                }
            }
        }));
}

});
parcelRegister("cpwiw", function(module, exports) {

$parcel$export(module.exports, "showUnmodifiableMacroFlag", () => $3d419e1dae817d20$export$752d3018048f7d27);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $8am3c = parcelRequire("8am3c");
const $3d419e1dae817d20$var$i18n = (0, $2nPZH.defineMessages)({
    unmodifiableMacroDialogTitle: {
        id: "fabric-extension-handlers.unmodifiable.macro.dialog.title",
        defaultMessage: "This macro can\u2019t be edited"
    },
    unmodifiableMacroDialogBody: {
        id: "fabric-extension-handlers.unmodifiable.macro.dialog.body",
        defaultMessage: "This macro was added to a page that was converted from the legacy editor. It can\u2019t be edited because it is now incompatible with the <alink>current editor</alink>."
    }
});
const $3d419e1dae817d20$export$752d3018048f7d27 = (selectedNode, flags, createAnalyticsEvent)=>new Promise((resolve, reject)=>{
        if (!selectedNode || !selectedNode.attrs || !flags) {
            reject(new Error('Cannot show unmodifiable macro error flag'));
            return;
        }
        const fireLinkClickAnalytics = ()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'unmodifiableMacroDialogComponentLearnMoreLink',
                    source: 'showUnmodifiableMacroFlag'
                }
            }).fire();
        };
        flags.showFlag({
            type: 'error',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3d419e1dae817d20$var$i18n.unmodifiableMacroDialogTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                ...$3d419e1dae817d20$var$i18n.unmodifiableMacroDialogBody,
                values: {
                    alink: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                            href: (0, $8am3c.LEARN_MORE_URL),
                            target: "_blank",
                            onClick: fireLinkClickAnalytics
                        }, chunks)
                }
            }),
            close: 'auto'
        });
        resolve();
    });

});
parcelRegister("8am3c", function(module, exports) {

$parcel$export(module.exports, "PLUGIN_KEY", () => $5f205cb1fe7d8e74$export$2dd355223baa0569);
$parcel$export(module.exports, "PAGE_MIGRATION_FEATURE_KEY", () => $5f205cb1fe7d8e74$export$73d3e00099fbbdb2);
$parcel$export(module.exports, "LEARN_MORE_URL", () => $5f205cb1fe7d8e74$export$af6d68522cb370b8);
const $5f205cb1fe7d8e74$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $5f205cb1fe7d8e74$export$73d3e00099fbbdb2 = 'confluence.fabric.page.migration.banner';
const $5f205cb1fe7d8e74$export$af6d68522cb370b8 = 'https://confluence.atlassian.com/confcloud/converting-pages-to-the-new-editor-993930226.html';

});



parcelRegister("krPyM", function(module, exports) {

let $ee2e52fe217d7ad5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ee2e52fe217d7ad5$var$load("iq6Zv").then(()=>parcelRequire('8pP5E'));

});


var $eb42712516f0a7b8$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"cRUrz\",\"ClassicEditorContextProvider.d4ac6afe.js\",\"2wLue\",\"confluence-macro-browser-overrides.74adc363.js\",\"fZNCx\",\"ClassicEditorContextProvider.e8594b47.js\",\"i0v79\",\"refractor.bf5a500a.js\",\"kJ4C4\",\"js.70ff2b00.js\",\"k7UyM\",\"png-chunks-extract.5f6af93f.js\",\"6KGrg\",\"EmojiComponent.c271d82a.js\",\"KsAVd\",\"GlobalFeedbackCollector.d9555043.js\",\"4aLlP\",\"cross-circle.88aa9f1f.js\",\"6ZETc\",\"smart-link.db91f489.js\",\"1lvsb\",\"EmojiTitlePopover.d3202fcb.js\",\"9Zd2C\",\"EmojiTitleButton.7abe412f.js\",\"dGk3x\",\"GlobalFeedbackCollector.384e16e2.js\",\"fhR3Z\",\"ErrorComponent.67f2b04e.js\",\"cyGuT\",\"feedback-collector.a12c128d.js\",\"hrAMe\",\"GlobalFeedbackCollector.2d17e151.js\",\"87F9B\",\"GlobalFeedbackCollector.aa051f84.js\",\"8Khwy\",\"GlobalFeedbackCollector.40653f6e.js\",\"b1HbL\",\"GlobalFeedbackCollector.111f9906.js\",\"fZyYv\",\"pubsub.b8b01595.js\",\"XgRtr\",\"EmojiPicker.f2cb22d0.js\",\"hUMW4\",\"render.43d26845.js\",\"1RolH\",\"EmojiPickerComponent.b3d86266.js\",\"1sEV4\",\"objects.48d1e20a.js\",\"cUIjD\",\"frequent.520eb35c.js\",\"3xznI\",\"search.f6ff3555.js\",\"6j8nK\",\"symbols.6a45f89a.js\",\"6Tafs\",\"people.b0b7dc9f.js\",\"etwBB\",\"activity.c4aa043b.js\",\"a2rZD\",\"custom.2ef1f801.js\",\"4yJnq\",\"add.48451125.js\",\"ePm95\",\"flags.a9c1eb51.js\",\"kJcWg\",\"food.e3210db9.js\",\"4tIwu\",\"nature.3ff4323e.js\",\"i1sL7\",\"travel.061004eb.js\",\"36ctu\",\"productivity.82ff59c6.js\",\"4hZJd\",\"EmojiTitleSelection.8aebb5e8.js\",\"hUvv7\",\"LiveDocsDefaultIcon.08feac8b.js\",\"5joXW\",\"GuestRequestToUpgradeToUser.923d615f.js\",\"1epse\",\"GuestRequestToUpgradeLearnMoreModal.5de0074b.js\",\"8Txex\",\"Guest-Avatar.ebdf69f1.svg\",\"2wyTK\",\"Team-Avatars.4f1b07ad.svg\",\"3wN5D\",\"ExternalSpaceLozenge.49a3cd81.js\",\"j3iEF\",\"CommentAddPromptNudgeText.d39b39bf.js\",\"lwUFR\",\"RequestAccessForUnassignedGuest.e3980f9f.js\",\"aad5M\",\"Collaboration-Bike.8735a1c6.svg\",\"7Ni3R\",\"GuestOnboardingModal.85e5147e.js\",\"WYAWv\",\"Guest-Onboarding-Light.8e788fbd.svg\",\"4rpM2\",\"Guest-Onboarding-Dark.f055cab3.svg\",\"hdVgj\",\"cs.1c005ee7.js\",\"lyv3S\",\"da.8793acc6.js\",\"l5Cmn\",\"de.d44753bc.js\",\"ir9sm\",\"en.5ab24af6.js\",\"jVOOe\",\"en_GB.df594e9a.js\",\"az6W3\",\"es.38b39ac7.js\",\"l4xmF\",\"et.c69a6267.js\",\"6yUii\",\"fi.d1d05d7d.js\",\"8WKdz\",\"fr.4bb6e966.js\",\"4ks37\",\"hu.0318af93.js\",\"3mznA\",\"is.c0d837b2.js\",\"55etM\",\"it.c93e0568.js\",\"9WKd2\",\"ja.54cc5c16.js\",\"lFhOg\",\"ko.a5db972c.js\",\"1TdK3\",\"nb.7af82b8d.js\",\"dFrhq\",\"nl.5a66ea64.js\",\"jWWrw\",\"pl.1bb6351c.js\",\"bStmt\",\"pt_BR.e887f189.js\",\"loug9\",\"pt_PT.1483b846.js\",\"ib3UG\",\"ro.74b22b36.js\",\"aLIWn\",\"ru.831472f2.js\",\"bifbn\",\"sk.6f967621.js\",\"5udVj\",\"sv.6a92ca3a.js\",\"linxm\",\"th.c5ea3c00.js\",\"BZsiM\",\"tr.8014708c.js\",\"4Lv3R\",\"uk.31053ba1.js\",\"16Kr3\",\"vi.83ea3bca.js\",\"dfZq9\",\"zh_TW.c4c672ad.js\",\"6h0Nb\",\"zh.94e86264.js\",\"9mi9f\",\"BannerSpacer.d1c2f472.js\",\"2pYvv\",\"LinkCardsExtension.fc17cd86.js\",\"i4cia\",\"component-lazy.f5275af3.js\",\"cMkgU\",\"16.e1eea079.js\",\"kDqHr\",\"file-icon.89bae4b8.js\",\"icyPI\",\"document-filled.faa05ec4.js\",\"4HZlX\",\"chart-bar-icon.9d482130.js\",\"7jSfd\",\"list-bullet-icon.5dd03672.js\",\"4x0L6\",\"people-group.37026955.js\",\"bZO0a\",\"people-group.f2c9d4ca.js\",\"k6H7B\",\"file--document-filled.788b6c93.js\",\"7OtNC\",\"16.94c7f155.js\",\"dzfxi\",\"16.d1f23644.js\",\"47wm8\",\"16.55954d26.js\",\"f28kH\",\"16.c9e936c8.js\",\"j2OLf\",\"16.312ea2e7.js\",\"fKONs\",\"16.c6567afc.js\",\"3c6qD\",\"16.2d1d228c.js\",\"b1gz4\",\"16.ad85e648.js\",\"8Xuep\",\"16.f0345f31.js\",\"abVVB\",\"16.b2fe424d.js\",\"l42ar\",\"16.9575b77d.js\",\"hlqS1\",\"16.2ab12708.js\",\"cea9f\",\"component-lazy.7820f354.js\",\"15APZ\",\"modal.627e694b.js\",\"kDLrp\",\"EmbedModal.cd1c55a0.js\",\"dUKeO\",\"vid-full-screen-on.0a813deb.js\",\"iiqDR\",\"vid-full-screen-off.319e7eb7.js\",\"i8IR3\",\"lock.063eb00e.js\",\"2RgZK\",\"modal.76d6dedf.js\",\"kO0mz\",\"audio-icon.d887b686.js\",\"jDjSj\",\"16.2135f1e5.js\",\"gQLjx\",\"angle-brackets-icon.9476c3db.js\",\"3wmvj\",\"16.f1002c31.js\",\"5i5pX\",\"folder-icon.b6117683.js\",\"eA5B3\",\"image-icon.2ca18334.js\",\"8059b\",\"16.910b552b.js\",\"7AsyI\",\"video-icon.5123ca59.js\",\"hPalR\",\"16.68e47c4d.js\",\"8LPnw\",\"lock-locked--lock-filled.3c3a79c2.js\",\"2fk6g\",\"16.8d4ad840.js\",\"dil5i\",\"24.47f09f24.js\",\"huUvS\",\"16.7c3f2c04.js\",\"P5iE2\",\"24.ff4a1396.js\",\"1oiJ6\",\"16.af157557.js\",\"42vdC\",\"24.690859f4.js\",\"lxiFd\",\"16.5f94e2dc.js\",\"9Bu2S\",\"24.41f5ad43.js\",\"eDqo1\",\"16.b194c043.js\",\"8pE8S\",\"24.37318bdb.js\",\"6HBYC\",\"16.bb69d575.js\",\"ivQYH\",\"24.3cba39bf.js\",\"bYxCZ\",\"16.02e33db5.js\",\"7a9CL\",\"24.a8f633e5.js\",\"eTBsW\",\"16.3af9f026.js\",\"8mzoy\",\"24.33c149b3.js\",\"020xd\",\"16.3cb1431f.js\",\"bjzRn\",\"24.49febb0a.js\",\"ls0Um\",\"16.4a76a1e3.js\",\"fYi1a\",\"24.381567fc.js\",\"eVYW1\",\"16.79b6a68f.js\",\"fqrMn\",\"24.6e5b47f6.js\",\"f35QR\",\"16.0f9246eb.js\",\"hzK1f\",\"24.9f87d7cb.js\",\"4sSyn\",\"24.732aeb1e.js\",\"dnrR3\",\"24.1f85d617.js\",\"gxkp2\",\"24.b66fea90.js\",\"hiqrg\",\"24.80ab73d0.js\",\"490Jr\",\"24.c6a44934.js\",\"ggkqU\",\"24.748c3243.js\",\"65smn\",\"24.52a54976.js\",\"1fh7t\",\"24.d00b548c.js\",\"4mLGd\",\"24.cff7d0c1.js\",\"cMlHc\",\"24.7583f89e.js\",\"lSzlP\",\"24.d4864e3e.js\",\"5erPe\",\"24.772760ac.js\",\"cXodu\",\"24.8c0985f6.js\",\"3vYMs\",\"attachment.03919ae3.js\",\"8PsNg\",\"attachment.19563af6.js\",\"9UmxH\",\"task.289c508b.js\",\"d1W0Z\",\"task.881698fc.js\",\"hlgZa\",\"component.87aad6ac.js\",\"aQnhg\",\"component.7e33af7a.js\",\"acQiP\",\"comment.48efe4f0.js\",\"2nh75\",\"comment.bd4c75fe.js\",\"jSJrn\",\"eye-open--watch.a5a01264.js\",\"jaTPo\",\"watch.45c04f55.js\",\"kgJcP\",\"thumbs-up--like.fe52cb3b.js\",\"dkV2T\",\"like.4d8ac070.js\",\"513ba\",\"arrow-up.3b94615f.js\",\"9f4oR\",\"arrow-up.914a48ac.js\",\"kefuj\",\"priority-blocker.9fea7215.js\",\"bWqqo\",\"priority-critical.be6a2f0f.js\",\"9ZeC1\",\"priority-high.b9c3d1f4.js\",\"9zpNb\",\"priority-highest.abb7d623.js\",\"gOpe6\",\"priority-low.48bc9dbc.js\",\"RAL03\",\"priority-lowest.bd6481c2.js\",\"5nQIT\",\"priority-major.6ebfd6da.js\",\"l9frT\",\"priority-medium.2fe1b52b.js\",\"lACXG\",\"priority-minor.da35d1bb.js\",\"ao5oO\",\"priority-trivial.bea1fc50.js\",\"7owaE\",\"question-circle--question.f34e2dad.js\",\"9PQvE\",\"angle-brackets--code.6d24e869.js\",\"9DPul\",\"code.4f51b08f.js\",\"9FBaW\",\"people-group--people.8e2e4e5d.js\",\"9dfxa\",\"subtasks--subtask.52d8630e.js\",\"hl2oi\",\"subtask.9408ce12.js\",\"3wY4G\",\"goal-icon.10748e67.js\",\"88r9N\",\"projects-icon.e5cb60ca.js\",\"cqZpg\",\"manual-triggers-modal.6e642462.js\",\"idfnC\",\"modal.770d6566.js\",\"aoU9B\",\"RelatedLinksModal.0fe5e8e7.js\",\"dTsOE\",\"modal.b91f8ec8.js\",\"18vkH\",\"modal.bfda36ab.js\",\"dle6z\",\"LinkCards.20cbf147.js\",\"jOQGL\",\"LinkCards.8b515810.js\",\"iuVYg\",\"RestrictedContent.b8a54c0d.svg\",\"kQxM6\",\"NoResults.9d75157a.svg\",\"iOWBI\",\"LinkCards.082cd107.js\",\"8dyWu\",\"CardMacroIcon.ec59e6f0.js\",\"iEvs6\",\"json-schema-validation.8dcf97a9.js\",\"kNILH\",\"PageContentRendererFabric.599ce97a.js\",\"jHYIB\",\"segment-highlight.becad587.js\",\"bCr24\",\"main.f8b76e0c.js\",\"lp0cK\",\"both-splash.465c87c4.svg\",\"bo7LK\",\"teams-splash.36cc0781.svg\",\"8XHrw\",\"slack-splash.73e116f6.svg\",\"6Yu8N\",\"main.7d3a5f27.js\",\"6zfzy\",\"modal.215ab670.js\",\"a4Sf9\",\"main.e4eccf22.js\",\"kpHRm\",\"GeneralShortcutListener.e16809a9.js\",\"cqNU4\",\"CommentWarningDialog.585c51a1.js\",\"1C6qR\",\"Reactions.19f6f1f2.js\",\"2PEGr\",\"monitoring.11721e57.js\",\"3co2g\",\"render.fbb62294.js\",\"2YtxS\",\"more.ffd79849.js\",\"aYGIV\",\"emoji-add.c43f9b90.js\",\"77ceh\",\"definition-popup-content.acb2ec68.js\",\"eSDS8\",\"modal.329d7c88.js\",\"bEo2Z\",\"standard.6c3cc6ed.svg\",\"9jQ73\",\"copy.9daf47fa.js\",\"bRtcL\",\"modal.205b7d54.js\",\"7fMGd\",\"dark.16cc06e7.svg\",\"8OP1c\",\"light.e350f7db.svg\",\"gywm1\",\"dark.981334ac.svg\",\"29by2\",\"light.d61b1f64.svg\",\"XXMwE\",\"dark.90199792.svg\",\"cqbvn\",\"light.5ffcf568.svg\",\"2zJ0a\",\"modal.fe5e7c1a.js\",\"64Goy\",\"modal.86176cc1.js\",\"k1740\",\"board.42589688.js\",\"2jsRt\",\"checkbox.ecab5960.js\",\"aQp8v\",\"radio.97b6e922.js\",\"gOlh9\",\"chevron-up.ee94df41.js\",\"aqWBW\",\"modal.444f51d1.js\",\"4fCJZ\",\"modal.cb451a6c.js\",\"kUAIU\",\"more.c0a8a98b.js\",\"4lfDj\",\"edit.9c07f953.js\",\"3ooAX\",\"download.0fd0515e.js\",\"9QvHa\",\"actual-size.8077ae01.js\",\"2w2Fa\",\"child-issues.e4a38055.js\",\"1hjmQ\",\"modal.d0af5800.js\",\"gavZG\",\"modal.69b1472b.js\",\"40QiO\",\"modal.b21febf1.js\",\"hdsgK\",\"modal.c1e33c42.js\",\"cSv6l\",\"dark.725705dc.svg\",\"hCwKF\",\"light.bf58aa10.svg\",\"4ru9N\",\"modal.c3d9353d.js\",\"7X74w\",\"modal.53cb6afe.js\",\"2Aekd\",\"modal.4b88a765.js\",\"3wTTx\",\"ParseTreePatternMatcher.e60dbf60.js\",\"15w0O\",\"modal.98f0f8ba.js\",\"gzdCt\",\"modal.910c63dd.js\",\"3BfJU\",\"modal.203e3816.js\",\"2RdVv\",\"modal.43662305.js\",\"42sOr\",\"modal.d10de78f.js\",\"759Sn\",\"modal.57a1a282.js\",\"02vME\",\"modal.29547ea4.js\",\"6UnNI\",\"CommentEditor.bcdcaec1.js\",\"hoUEM\",\"simpleHasher.fb2f1c66.js\",\"b0HBF\",\"CoreInvites.17b15726.js\",\"4lrAQ\",\"FullPageEditorComponent.932a064e.js\",\"1ZAFx\",\"charts.04f471dc.js\",\"jCu7l\",\"root-component.55b3a834.js\",\"kB1sA\",\"CommentEditor.f184fff2.js\",\"l40lY\",\"ufo.eafbb529.js\",\"bku9v\",\"definition-popup-content.e1b3f595.js\",\"iuLvL\",\"FullPageEditorComponent.a63114f4.js\",\"jcdL6\",\"action.8c8cd1b7.js\",\"8SMhH\",\"code.c2d56d85.js\",\"bxYOE\",\"date.a603fcdc.js\",\"f0zmS\",\"decision.7d328f3a.js\",\"ggLwo\",\"divider.c62945e9.js\",\"1p2DU\",\"emoji.1b9ce643.js\",\"1RKLZ\",\"images.110ac9fa.js\",\"7i9aD\",\"layout.cb129077.js\",\"4VRIj\",\"link.46918210.js\",\"djSOz\",\"list-number.2680f0e5.js\",\"irpaz\",\"list.2d601c3e.js\",\"3SeOO\",\"mention.d140f567.js\",\"5se79\",\"panel-error.cb8b2b76.js\",\"9bXCA\",\"panel-note.c66d3b75.js\",\"1WrE2\",\"panel-success.df94f2c5.js\",\"fnpAC\",\"panel-warning.5debdf01.js\",\"gMSS1\",\"panel.faea93b3.js\",\"e1MXN\",\"quote.08ae46a7.js\",\"4dn8m\",\"status.77676360.js\",\"9E19j\",\"one-column-layout.9bec948b.js\",\"bDOK7\",\"two-column-layout.ac1a0c0b.js\",\"jhuLr\",\"three-column-layout.20c6780a.js\",\"gMvtj\",\"four-column-layout.895e55a4.js\",\"7unhY\",\"five-column-layout.ad3099e5.js\",\"aKgoC\",\"heading1.2ecc3cdd.js\",\"9ygQy\",\"heading2.9a11070d.js\",\"kTaDo\",\"heading3.2ac51234.js\",\"d2kuO\",\"heading4.e18ab819.js\",\"6wLYX\",\"heading5.5c05c118.js\",\"eVKfF\",\"heading6.3f592dc0.js\",\"b4NwV\",\"feedback.d325a188.js\",\"h9aqE\",\"expand.fa6b07d5.js\",\"jXrdN\",\"datasource-jira-issue.82db85f8.js\",\"9Bneg\",\"datasource-assets-objects.b1c98d73.js\",\"1lXr0\",\"datasource-confluence-search.801d23d6.js\",\"bHGMG\",\"loom.fb83b9e9.js\",\"aA6N2\",\"Toolbar.b917d5c6.js\",\"jD7Po\",\"CommentEditor.61481a6b.js\",\"1ugoC\",\"CommentEditor.8c1a800c.js\",\"iAspJ\",\"Toolbar.c68d3c2b.js\",\"lsAHy\",\"FullPageEditorComponent.a8db3a4a.js\",\"5WLpx\",\"ElementBrowser.3060cad1.js\",\"boDjZ\",\"CommentEditor.21e9a040.js\",\"awc2s\",\"ProjectLinker.e233ca17.js\",\"c0JsV\",\"link-picker.4ed92498.js\",\"g5rGe\",\"HelpPanel.e92828e0.js\",\"bgvYl\",\"cs.4ba470ca.js\",\"b39oP\",\"da.2757cc56.js\",\"aeErk\",\"de.e9d905c4.js\",\"kDs7y\",\"en_GB.3b8003b8.js\",\"jp5mX\",\"en_ZZ.f4a8a349.js\",\"aWhd2\",\"es.51161513.js\",\"j7gH4\",\"fi.f27ca3d6.js\",\"bqAzS\",\"fr.4dc9bdc1.js\",\"9i8rS\",\"hu.aca870b5.js\",\"dJLWv\",\"it.747f4681.js\",\"kWbs6\",\"ja.931e2d18.js\",\"835WZ\",\"ko.7d5a17a6.js\",\"d6wjH\",\"nb.37a856d1.js\",\"lk62y\",\"nl.63491589.js\",\"dJiiw\",\"pl.37a82474.js\",\"igUcR\",\"pt_BR.4d87c8f0.js\",\"clhk4\",\"ru.008210fc.js\",\"drGhL\",\"sv.8bb6f6e5.js\",\"jYGxH\",\"th.939e2134.js\",\"czAFw\",\"tr.0337f418.js\",\"c0Efy\",\"uk.44959921.js\",\"dKBuH\",\"vi.0a0fe683.js\",\"7eCND\",\"zh_TW.4675a2ac.js\",\"8SArD\",\"zh.ac524d15.js\",\"2hQcx\",\"CommentEditor.61649b2a.js\",\"1LhCD\",\"definition-popup-content.409bf496.js\",\"eArsa\",\"definition-popup-content.f866b623.js\",\"EfTik\",\"hoverCard.9dd83053.js\",\"lb9xb\",\"smart-card.c29bca4a.js\",\"cPSQq\",\"renderer.432cc294.js\",\"5pCOW\",\"HelpPanel.a4b79bca.js\",\"cNnZR\",\"HelpPanel.aafa482b.js\",\"1MwaY\",\"HelpPanel.runtime.033474f5.js\",\"1MwaY\",\"HelpPanel.runtime.033474f5.js\",\"9tyrK\",\"react-markdown.110e43f2.js\",\"6PtxN\",\"cs.4af6da41.js\",\"8RKtn\",\"da.00cc494f.js\",\"fCIoO\",\"de.feb55cf0.js\",\"1geBW\",\"es.2b9a509c.js\",\"5WU5D\",\"et.c12c2abb.js\",\"i1Uow\",\"fi.577f953a.js\",\"3ZuKT\",\"fr.6da7024a.js\",\"5nJlY\",\"hu.3d953190.js\",\"Uq5C2\",\"it.d747a7e7.js\",\"9TzAL\",\"ja.6cac578c.js\",\"oPAjm\",\"ko.e5176471.js\",\"3fvcK\",\"nb.cf4f3e33.js\",\"iMYDs\",\"nl.0646b6ed.js\",\"jPHqC\",\"pl.7e10aa61.js\",\"3saM6\",\"pt_BR.2e845e69.js\",\"4hCdo\",\"pt_PT.3585f16f.js\",\"78gs3\",\"ru.6f4b63fe.js\",\"2XhMA\",\"sk.9b031399.js\",\"f7Egw\",\"sv.567af81d.js\",\"aiZUj\",\"tr.5656666a.js\",\"6rH3p\",\"th.f0261be3.js\",\"lS1VG\",\"uk.fe1da325.js\",\"fFbe4\",\"vi.32dd8df9.js\",\"7JTjB\",\"zh_TW.3a48b1fe.js\",\"dMjyc\",\"zh.37507780.js\",\"17xYa\",\"definition-popup-content.8bc15983.js\",\"fhU7k\",\"esm.3729572a.js\",\"7jwEY\",\"esm.eef6c309.js\",\"jdeAV\",\"esm.c5711a0d.js\",\"h0Exi\",\"definition-popup-content.22fa3579.js\",\"lnKog\",\"main.f4914994.js\",\"avRkh\",\"ReadingAidsPopup.3d600d5b.js\",\"gJjCK\",\"InlineCommentNudge.21a91c6d.js\",\"kugUh\",\"ReattachCommentPanel.47b23696.js\",\"dnPXT\",\"spotlightImage.33d23bc6.svg\",\"hOsjc\",\"ResolvedInlineCommentsDialog.5543480e.js\",\"km34l\",\"ResolvedInlineCommentsQueryRenderer.cd743eb6.js\",\"aS96v\",\"ResolvedInlineCommentsCounter.3d0af8c0.js\",\"410C5\",\"ContextualCreateContentPopoverMenu.be43116a.js\",\"ipTFT\",\"EndOfPageRecommendation.afcd2343.js\",\"eCgOQ\",\"EndOfPageRecommendation.7e130d77.js\",\"3TNOq\",\"EndOfPageRecommendation.d88d526e.js\",\"3kHns\",\"WatchDialog.d2552132.js\",\"7kdzx\",\"EndOfPageRecommendation.51a3bed8.js\",\"ac6oS\",\"QuickSummaryPopup.5422cfb6.js\",\"h7Fyj\",\"quick_summary_spotlight.2a439c01.gif\",\"k4PhO\",\"global-opt-in-default-image-banner.cf053e66.svg\",\"jrchu\",\"QuickSummaryStreamingEntryPoint.9ef7f703.js\",\"kUbT8\",\"AISummaryFooter.d7f05eb6.js\",\"gYdbF\",\"HelpPanel.97b92c13.js\",\"emd3r\",\"AISummaryFooter.f7ea8ce0.js\",\"hcY7w\",\"SmartsSummaryErrorComponent.ae71fa9f.js\",\"gO8Rd\",\"QuickSummaryStreamingEntryPoint.9e2df76f.js\",\"9zj4V\",\"QuickSummaryStreamingEntryPoint.4e602e1d.js\",\"9zpRH\",\"QuickSummaryStreamingEntryPoint.df64d3bf.js\",\"9X5xA\",\"quickSummaryUpsellBannerLight.edcc3647.svg\",\"iLB51\",\"quickSummaryUpsellBannerDark.e27429f6.svg\",\"aK31u\",\"PageContentRendererFabric.5ba26f82.js\",\"9j6kV\",\"PageContentRendererFabric.runtime.8f102440.js\",\"7zya2\",\"FullPageEditorComponent.d65f70b4.js\",\"hL0TZ\",\"PageContentRendererFabric.f94dde20.js\",\"8Ovry\",\"CommentEditor.b70123f7.js\",\"7Vmxp\",\"table.2dd4e4dd.js\",\"koKgZ\",\"datasourceRenderFailedAnalyticsWrapper.d7c01868.js\",\"7ixUU\",\"datasourceTableView.ffec6178.js\",\"91C8u\",\"refresh.91a3998f.js\",\"fwuXj\",\"cardWithMediaClient.839764e4.js\",\"cKkZK\",\"media-viewer-error-boundary.e05937be.js\",\"bHwQq\",\"archive.19d56a53.js\",\"2OhRQ\",\"codeViewerRenderer.9d07c2ce.js\",\"37ldp\",\"ErrorComponent.0cf690f4.js\",\"9vSeI\",\"audio.ab8e1202.js\",\"4FLkP\",\"archive.84dcd686.js\",\"e53Dv\",\"vid-play.ef7a3553.js\",\"5rLJa\",\"vid-pause.8e6eb119.js\",\"6dDCB\",\"outgoing-sound.af1ddf18.js\",\"8PuzS\",\"archive.556bbd3e.js\",\"lixGB\",\"78-EUC-H.51d0c3f9.js\",\"fH2pk\",\"78-EUC-V.64ff1cfd.js\",\"kZB45\",\"78-H.0ed13b16.js\",\"6BxSI\",\"78-RKSJ-H.dc86b34e.js\",\"i9zPw\",\"78-RKSJ-V.82830549.js\",\"8Qq8X\",\"78-V.b650b3b6.js\",\"hUHQJ\",\"78ms-RKSJ-H.8d99de38.js\",\"4Y4SR\",\"78ms-RKSJ-V.d9f17393.js\",\"axQaS\",\"83pv-RKSJ-H.f8767ab6.js\",\"hh6Ks\",\"90ms-RKSJ-H.d832d6a6.js\",\"gyPUO\",\"90ms-RKSJ-V.260dbffb.js\",\"aduQJ\",\"90msp-RKSJ-H.364f2808.js\",\"3iFld\",\"90msp-RKSJ-V.aa85de80.js\",\"6XUCn\",\"90pv-RKSJ-H.848d9bac.js\",\"8eJG6\",\"90pv-RKSJ-V.92513b15.js\",\"iveJ5\",\"Add-H.729159c7.js\",\"kOqxj\",\"Add-RKSJ-H.2baf4c23.js\",\"1zYOj\",\"Add-RKSJ-V.24c188d0.js\",\"2MU2T\",\"Add-V.f276585e.js\",\"oH9eX\",\"Adobe-CNS1-0.c94fb46d.js\",\"fSa6m\",\"Adobe-CNS1-1.22c8a053.js\",\"g2oEO\",\"Adobe-CNS1-2.b6e41c65.js\",\"8WzHR\",\"Adobe-CNS1-3.6168987e.js\",\"ca0bh\",\"Adobe-CNS1-4.44238a8c.js\",\"cfcpu\",\"Adobe-CNS1-5.62d26997.js\",\"li5lK\",\"Adobe-CNS1-6.7ebee211.js\",\"kujwR\",\"Adobe-CNS1-UCS2.0dd5c8ce.js\",\"8iFzj\",\"Adobe-GB1-0.249f5de6.js\",\"6D5co\",\"Adobe-GB1-1.74dabbbf.js\",\"cfFSd\",\"Adobe-GB1-2.4a68d0c8.js\",\"exff1\",\"Adobe-GB1-3.b5b05f5d.js\",\"aeuVs\",\"Adobe-GB1-4.c9dd9584.js\",\"aLrjO\",\"Adobe-GB1-5.0e92a2eb.js\",\"j3PYN\",\"Adobe-GB1-UCS2.bb70ebea.js\",\"d0uYO\",\"Adobe-Japan1-0.4d890a6e.js\",\"eEcvV\",\"Adobe-Japan1-1.a0781bed.js\",\"820v9\",\"Adobe-Japan1-2.9f2dc797.js\",\"frVgA\",\"Adobe-Japan1-3.15951cff.js\",\"jdQzX\",\"Adobe-Japan1-4.0cfae895.js\",\"Z8yoS\",\"Adobe-Japan1-5.66dd1b5b.js\",\"k2vqy\",\"Adobe-Japan1-6.7e06fceb.js\",\"kgt4y\",\"Adobe-Japan1-UCS2.e121ba74.js\",\"eP0RM\",\"Adobe-Korea1-0.ab6029ff.js\",\"gA5f7\",\"Adobe-Korea1-1.f58d7af7.js\",\"i4Ed8\",\"Adobe-Korea1-2.90e46d21.js\",\"l6X7m\",\"Adobe-Korea1-UCS2.37651d5b.js\",\"aphLF\",\"B5-H.35e26a2d.js\",\"7EoeH\",\"B5-V.af3f0204.js\",\"6Q7ZY\",\"B5pc-H.e4f1d7a8.js\",\"8cnq9\",\"B5pc-V.8f5377c3.js\",\"7NcV5\",\"CNS-EUC-H.6bb831b5.js\",\"cxpt9\",\"CNS-EUC-V.8c378414.js\",\"l27ve\",\"CNS1-H.ea7d046f.js\",\"c6rCW\",\"CNS1-V.1fdf3e4e.js\",\"3upsV\",\"CNS2-H.705fd9e8.js\",\"k9G9k\",\"CNS2-V.c55f4d63.js\",\"bDgpL\",\"ETHK-B5-H.7f8e45d5.js\",\"33eqd\",\"ETHK-B5-V.09bf3c22.js\",\"5F3PA\",\"ETen-B5-H.05fb1408.js\",\"hfiT2\",\"ETen-B5-V.5e380c42.js\",\"jMuj8\",\"ETenms-B5-H.3891364b.js\",\"gNTCu\",\"ETenms-B5-V.394705ca.js\",\"6rTQb\",\"EUC-H.b991c232.js\",\"l89SH\",\"EUC-V.0ac4677e.js\",\"iEkij\",\"Ext-H.5968bae5.js\",\"eVVKx\",\"Ext-RKSJ-H.d9938a5e.js\",\"kL3q4\",\"Ext-RKSJ-V.e9a51cbe.js\",\"avDfo\",\"Ext-V.74d1f996.js\",\"l3LgN\",\"GB-EUC-H.910bba6d.js\",\"eIBS8\",\"GB-EUC-V.0c6edfac.js\",\"8HXb3\",\"GB-H.92bed904.js\",\"lWK2A\",\"GB-V.4564569a.js\",\"iYIwI\",\"GBK-EUC-H.f5f68a8f.js\",\"g4Lp1\",\"GBK-EUC-V.97682197.js\",\"9jlRI\",\"GBK2K-H.edc4a051.js\",\"g2IgM\",\"GBK2K-V.46c62554.js\",\"24SBU\",\"GBKp-EUC-H.da565c58.js\",\"gzU5W\",\"GBKp-EUC-V.d5927fe2.js\",\"jN4tb\",\"GBT-EUC-H.267ac8c0.js\",\"6fVUl\",\"GBT-EUC-V.7720b25f.js\",\"e0AMV\",\"GBT-H.974fe797.js\",\"htjXf\",\"GBT-V.12defd7a.js\",\"hWeIU\",\"GBTpc-EUC-H.43d524d7.js\",\"1eaMl\",\"GBTpc-EUC-V.c77ba0fc.js\",\"fDvqM\",\"GBpc-EUC-H.08408830.js\",\"2de5A\",\"GBpc-EUC-V.ddbe12a3.js\",\"19tEv\",\"H.8a76eaa0.js\",\"j0hRA\",\"HKdla-B5-H.e6a4bedb.js\",\"fd9qd\",\"HKdla-B5-V.94816590.js\",\"e9cdN\",\"HKdlb-B5-H.41238054.js\",\"aNHZK\",\"HKdlb-B5-V.c7a56f0d.js\",\"hgC4a\",\"HKgccs-B5-H.423aefeb.js\",\"eEaBv\",\"HKgccs-B5-V.fff775c8.js\",\"fYV0G\",\"HKm314-B5-H.60d4b9bb.js\",\"dJs80\",\"HKm314-B5-V.997bace9.js\",\"4Y1kq\",\"HKm471-B5-H.0a6f2053.js\",\"hYpsA\",\"HKm471-B5-V.5588cb3b.js\",\"9xkOt\",\"HKscs-B5-H.cbf6db19.js\",\"lm69C\",\"HKscs-B5-V.cf9a31dc.js\",\"kva4v\",\"Hankaku.ca0ba78b.js\",\"5AfTB\",\"Hiragana.85378b4a.js\",\"3TaY6\",\"KSC-EUC-H.aff5022e.js\",\"8wf7j\",\"KSC-EUC-V.3949c72d.js\",\"cgHyF\",\"KSC-H.4ed431c9.js\",\"cxq0E\",\"KSC-Johab-H.22d6dfec.js\",\"ipw37\",\"KSC-Johab-V.0ee59f70.js\",\"aD76K\",\"KSC-V.dc2b8859.js\",\"8okaY\",\"KSCms-UHC-H.b54f6070.js\",\"i7fxp\",\"KSCms-UHC-HW-H.998acbf6.js\",\"7fYMC\",\"KSCms-UHC-HW-V.0a3c59db.js\",\"imOx6\",\"KSCms-UHC-V.37c6be44.js\",\"gKF8I\",\"KSCpc-EUC-H.4cfc83d8.js\",\"9m5PS\",\"KSCpc-EUC-V.5881e143.js\",\"8asvD\",\"Katakana.321c2f5f.js\",\"7HkN3\",\"NWP-H.6a69fa60.js\",\"isnju\",\"NWP-V.88613bd5.js\",\"f31m2\",\"RKSJ-H.2af2abd8.js\",\"2VYvR\",\"RKSJ-V.65a07798.js\",\"1KF3Q\",\"Roman.ca13d8f3.js\",\"29QIq\",\"UniCNS-UCS2-H.f2596cac.js\",\"dVqyh\",\"UniCNS-UCS2-V.4be9430a.js\",\"7UKDA\",\"UniCNS-UTF16-H.bb71adc5.js\",\"Q9KG4\",\"UniCNS-UTF16-V.d89c4950.js\",\"c2z6B\",\"UniCNS-UTF32-H.6ef36f87.js\",\"lTznr\",\"UniCNS-UTF32-V.c838593e.js\",\"7t7V6\",\"UniCNS-UTF8-H.77d5771f.js\",\"lcMXU\",\"UniCNS-UTF8-V.70a7ba9f.js\",\"4Y11P\",\"UniGB-UCS2-H.1303e3c8.js\",\"6MnqR\",\"UniGB-UCS2-V.c4668ab1.js\",\"eQt1R\",\"UniGB-UTF16-H.d1be3be2.js\",\"fm8Lw\",\"UniGB-UTF16-V.a072ba07.js\",\"4l8L7\",\"UniGB-UTF32-H.e2d1c79f.js\",\"1tDis\",\"UniGB-UTF32-V.76c200be.js\",\"2Vv5T\",\"UniGB-UTF8-H.41f4baba.js\",\"iWa77\",\"UniGB-UTF8-V.8ed42052.js\",\"38Eab\",\"UniJIS-UCS2-H.e0c99f94.js\",\"lDeVy\",\"UniJIS-UCS2-HW-H.2086623a.js\",\"8aWy7\",\"UniJIS-UCS2-HW-V.ffb2caeb.js\",\"76QHL\",\"UniJIS-UCS2-V.21ffe4a5.js\",\"lRW10\",\"UniJIS-UTF16-H.4216604d.js\",\"aJpvy\",\"UniJIS-UTF16-V.48b4e738.js\",\"7s6rx\",\"UniJIS-UTF32-H.038159ea.js\",\"jUs4H\",\"UniJIS-UTF32-V.34681c47.js\",\"a8YIF\",\"UniJIS-UTF8-H.3f187918.js\",\"fH9Jk\",\"UniJIS-UTF8-V.dd6be6a0.js\",\"13MuZ\",\"UniJIS2004-UTF16-H.c4a60299.js\",\"hwfXT\",\"UniJIS2004-UTF16-V.2dbaf4f4.js\",\"dGSeC\",\"UniJIS2004-UTF32-H.dba66596.js\",\"9rrYA\",\"UniJIS2004-UTF32-V.74761cad.js\",\"7d1OI\",\"UniJIS2004-UTF8-H.4ec8549f.js\",\"809oM\",\"UniJIS2004-UTF8-V.c5cc5b20.js\",\"bdrR8\",\"UniJISPro-UCS2-HW-V.4031e777.js\",\"4D2EW\",\"UniJISPro-UCS2-V.5072efde.js\",\"cdY8a\",\"UniJISPro-UTF8-V.7adee45d.js\",\"avqzB\",\"UniJISX0213-UTF32-H.56363b94.js\",\"j845q\",\"UniJISX0213-UTF32-V.6e415ebf.js\",\"emImx\",\"UniJISX02132004-UTF32-H.80a3d411.js\",\"f6AOW\",\"UniJISX02132004-UTF32-V.75e044a9.js\",\"7pSug\",\"UniKS-UCS2-H.4ff5f169.js\",\"465mT\",\"UniKS-UCS2-V.af99e23d.js\",\"3w6Hd\",\"UniKS-UTF16-H.b031c3f9.js\",\"4T3rW\",\"UniKS-UTF16-V.dbaec3f8.js\",\"d8Hqs\",\"UniKS-UTF32-H.11f34035.js\",\"77ADK\",\"UniKS-UTF32-V.344d4ef0.js\",\"dkDCu\",\"UniKS-UTF8-H.a4bf67c4.js\",\"8Qdf7\",\"UniKS-UTF8-V.af9521f3.js\",\"bhNwf\",\"V.5ce814bb.js\",\"ioEN1\",\"WP-Symbol.9e3226a6.js\",\"ahb4M\",\"archive.0d27d385.js\",\"hGXAt\",\"arrow-left.4e36be28.js\",\"edP6u\",\"home.27001c49.js\",\"3wpjh\",\"image.5e30e73c.js\",\"869mA\",\"video.5fba53cf.js\",\"j7Vtd\",\"audio.f01e638c.js\",\"f33Ay\",\"doc.2b4e2e78.js\",\"2JEgu\",\"codeViewer.13d8c506.js\",\"gQYJt\",\"svg.efbec00b.js\",\"9ldIR\",\"cardWithMediaClient.f707c0c6.js\",\"gFHfi\",\"zoom-out.3da7e413.js\",\"4uhcp\",\"zoom-in.07cb82b6.js\",\"doomh\",\"chevron-left-circle.e397c0ae.js\",\"lnWRh\",\"chevron-right-circle.361ff8d8.js\",\"8Ozg8\",\"inlinePlayer.f1ba673a.js\",\"9jsMO\",\"cardWithMediaClient.4f1c01cd.js\",\"6aruy\",\"media-client-react.fe92702a.js\",\"4M7W5\",\"mediaInlineCard.8e765524.js\",\"iP5Bv\",\"mediaInlineAnalyticsErrorBoundary.d2724591.js\",\"5Pnad\",\"cs.956703b3.js\",\"3qzeo\",\"da.a6e51006.js\",\"4UYlu\",\"de.0e52901f.js\",\"3qbnQ\",\"en.c857dc06.js\",\"HY4Vc\",\"en_GB.8088c875.js\",\"fJQPR\",\"en_ZZ.67fbfeed.js\",\"gxipV\",\"es.69f016fd.js\",\"3uZ1q\",\"et.ac1a0ae0.js\",\"ardvv\",\"fi.be067ec8.js\",\"cjhdF\",\"fr.498beda1.js\",\"2mWUI\",\"hu.c32b69d9.js\",\"29Sce\",\"is.02c33977.js\",\"dBvXj\",\"it.fbe42f1a.js\",\"gmdLX\",\"ja.3923bf19.js\",\"fcXn9\",\"ko.419acfa2.js\",\"lH0NU\",\"nb.082125cc.js\",\"3OEsN\",\"nl.7ba79509.js\",\"hGLdi\",\"pl.d68b8afc.js\",\"Xi5AP\",\"pt_BR.ea61b74c.js\",\"f7XHA\",\"pt_PT.e565d94b.js\",\"14AZs\",\"ro.699a99b7.js\",\"lsFbX\",\"ru.1a33c100.js\",\"ibz6c\",\"sk.b538319e.js\",\"7I8FK\",\"sv.e3c6634e.js\",\"l7PQP\",\"th.93fb5ab5.js\",\"4iSRl\",\"tr.0b957c49.js\",\"fLjHM\",\"uk.7a8159bb.js\",\"3YGga\",\"vi.a291c6ef.js\",\"7yGIa\",\"zh_TW.018b8e11.js\",\"dZksg\",\"zh.be550b65.js\",\"2lsX7\",\"main.e4c0dc41.js\",\"c9Qqc\",\"auto-dev.8d61d094.js\",\"1TK6P\",\"auto-fix.40d5643a.js\",\"grvAy\",\"auto-review.b30e0495.js\",\"23K0q\",\"backlog-buddy.546cc235.js\",\"3kQkj\",\"comms-crafter.a429b953.js\",\"6OXgE\",\"culture.c94a4d0c.js\",\"cbucA\",\"customer-insight.9e5c421c.js\",\"bVhr1\",\"decision-director.ded178c7.js\",\"kE0QC\",\"feature-flag-avatar.d96a4871.js\",\"eVFXf\",\"generic-avatar.b15ebaec.js\",\"9FhBz\",\"hire-writer.b3c71c2d.js\",\"6zB8z\",\"marketing-message-maestro.faf8f74a.js\",\"eENGY\",\"my-user-manual.6ff987c9.js\",\"hmlb0\",\"okr-oracle.82efe566.js\",\"2NGxc\",\"ops-agent.6f5fdecd.js\",\"bPgcq\",\"pitch-perfector.ab0ed7cc.js\",\"31b1q\",\"product-requirement.b09341f4.js\",\"8Lh9U\",\"release-notes.1ed87232.js\",\"6ZzYJ\",\"research-scout.6b05852d.js\",\"410SS\",\"social-media-scribe.f4f5f4f0.js\",\"z3s9q\",\"team-connection.ad9a07ec.js\",\"9gqcE\",\"workflow-builder.f73007e6.js\",\"hXu5I\",\"plussquare.402ef5a0.js\",\"kkycx\",\"issue-raise.03dcd0e3.js\",\"7lyIx\",\"page.bd097046.js\",\"esvqD\",\"page.1a0b7fa5.js\",\"a0oMZ\",\"ui.c3ed1542.js\",\"i1TuF\",\"cs.2190cb07.js\",\"eEPT4\",\"da.02eaca38.js\",\"gkfGT\",\"de.90355bf8.js\",\"6kSRw\",\"en.32193a4b.js\",\"2dFTF\",\"en_GB.09598cb2.js\",\"auo6z\",\"en_ZZ.f14ca7c2.js\",\"685rk\",\"es.8fa0593c.js\",\"fp6pG\",\"fi.71fd59df.js\",\"6bt8l\",\"fr.40c5717d.js\",\"jjvsl\",\"hu.50ccd7da.js\",\"bAfbH\",\"it.e0e7a6ba.js\",\"5Q9X0\",\"ja.2dfec41f.js\",\"ePkyJ\",\"ko.0b1ec89d.js\",\"hpdFn\",\"nb.b2e768d2.js\",\"8qW90\",\"nl.7f781ad8.js\",\"a1OSV\",\"pl.ca25a045.js\",\"8AvOI\",\"pt_BR.eb536358.js\",\"jxu37\",\"ru.3bbb4cd9.js\",\"10YQF\",\"sv.b02b2c4a.js\",\"daBgp\",\"tr.1172519d.js\",\"bI6N0\",\"th.b72c3249.js\",\"3Qhls\",\"uk.c5a9160e.js\",\"dgXIC\",\"vi.98dce50e.js\",\"jh4hi\",\"zh_TW.79a7157d.js\",\"2AL0H\",\"zh.29b1c23a.js\",\"iaptT\",\"Page.73743678.js\",\"kG8pF\",\"ViewPage.087efccf.js\",\"1Rd9w\",\"ViewPage.486efe57.js\",\"4YF8c\",\"EditPage.bffcdac5.js\",\"lPCqB\",\"FullPageEditorComponent.3fdd636c.js\",\"8KDBK\",\"inline-create-one-step-experiment.d5f98145.js\",\"7XFs3\",\"QuickReload.f11506d1.js\",\"6tlHd\",\"image.56987714.js\",\"dIuhJ\",\"link-filled.613880d0.js\",\"e6bZt\",\"QuickReload.d1383c39.js\",\"dGO6Y\",\"QuickReload.250ad85c.js\",\"gZUCP\",\"document.ed659816.js\",\"dsbZs\",\"video.17f9ddc6.js\",\"6iF9L\",\"root-component.f191268b.js\",\"1KyrT\",\"root-component.a110db48.js\",\"2HlAY\",\"root-component.99411091.js\",\"6cVEd\",\"fire-event.b3bc942e.js\",\"1S9KM\",\"lock-locked--lock-circle.b585a6b1.js\",\"bL008\",\"lock-circle.71a95545.js\",\"np2ZB\",\"NonMasteredUserModal.0de36a57.js\",\"j2eUy\",\"nonMasteredUserModalSplashImage.90ba8397.svg\",\"hq1Iv\",\"masteringFlowSplashImage.1f9bd0cc.svg\",\"2a8Ft\",\"is-supported.2cc000b0.js\",\"cvmv4\",\"esm.cfe3b506.js\",\"daoWf\",\"LoomCrossSellPopupCardImage.6e60c328.png\",\"014Eq\",\"pageHeaderSpotlightImage.b1e98e59.png\",\"ipnbL\",\"createSpotlightImage.f64dc988.png\",\"jBwbI\",\"LoomMigrationModalManager.64b041e1.js\",\"3jZMP\",\"loomMigrationModalImage.fa8ef03b.svg\",\"1wrZ9\",\"vector.07efb279.svg\",\"h9hWQ\",\"SimpleEmoji.812ca16f.js\",\"9p2N9\",\"ui.a4716d13.js\",\"hqblC\",\"browser.81d741f9.js\",\"7oUma\",\"browser.db399c79.js\",\"cCWZm\",\"dropzone.0237a321.js\",\"lE3cg\",\"media-picker-analytics-error-boundary.46ab178b.js\",\"2KJHS\",\"esm.54c1d85f.js\",\"3FT39\",\"cs.b4709f80.js\",\"7QoTg\",\"da.e788fd22.js\",\"d1Lrf\",\"de.2dd434ed.js\",\"kM5GB\",\"en_GB.82797faf.js\",\"5506N\",\"en_ZZ.a7c6e9ad.js\",\"7ioy0\",\"es.a4af58eb.js\",\"kZ6zs\",\"fi.aaa32cea.js\",\"phbpE\",\"fr.0e55ec47.js\",\"6pKhl\",\"hu.8153cc96.js\",\"hzLOt\",\"it.75418871.js\",\"1M8mW\",\"ja.6ef7e39a.js\",\"eHQAY\",\"ko.36b5b8ee.js\",\"8exPB\",\"nb.9e9e6a03.js\",\"knfAP\",\"nl.dbd0c739.js\",\"ljRXP\",\"pl.7932a8db.js\",\"bEb8c\",\"pt_BR.e2f7c972.js\",\"c7JYF\",\"ru.a2b7a11a.js\",\"ari8V\",\"sv.1d81f4cf.js\",\"kfrHX\",\"th.0d215dce.js\",\"aWToy\",\"tr.9415008a.js\",\"4ns5x\",\"uk.baa17c6e.js\",\"7bfAn\",\"vi.26b5754b.js\",\"gftgT\",\"zh_TW.b791e5b1.js\",\"6YVlG\",\"zh.ccb62d88.js\",\"fLvJM\",\"PageHeaderLoomEntryPoint.ec3d9918.js\",\"49SvW\",\"PageHeaderLoomEntryPoint.3bcf9869.js\",\"9EW0B\",\"PageHeaderLoomEntryPoint.368c1286.js\",\"iLgOr\",\"PageHeaderLoomEntryPoint.9d39546e.js\",\"eufZR\",\"PageHeaderLoomEntryPoint.7dd150a6.js\",\"klDll\",\"PageHeaderLoomEntryPoint.6769d167.js\",\"6wlp3\",\"CommentEditor.d2b00fc5.js\",\"1jn79\",\"FullPageEditorComponent.c5a45ddb.js\",\"dnE79\",\"editor-ai-opt-in-banner.523b2454.svg\",\"6z3SN\",\"BrowseRovoAgentsModal.85df0acc.js\",\"gXUq7\",\"AgentProfileCard.b8596e60.js\",\"erM4f\",\"star-filled.25b568ab.js\",\"6FSEq\",\"star.44632513.js\",\"g2v3v\",\"BrowseRovoAgentsModal.74f764c7.js\",\"iwtoQ\",\"BrowseRovoAgentsModal.e441f7bf.js\",\"g7pmM\",\"suitcase.516b4ed4.js\",\"7l3QW\",\"FullPageEditorComponent.9af3358e.js\",\"jrNlW\",\"CommentEditor.b5806fad.js\",\"ftgqK\",\"CommentEditor.b4a2b2b6.js\",\"l4ZLl\",\"FullPageEditorComponent.38788ad1.js\",\"5doAZ\",\"DatePicker.e83188fc.js\",\"9KJWc\",\"clipboard.7684b21e.js\",\"f4KyF\",\"FullPageEditorComponent.3d1483df.js\",\"b886X\",\"CommentEditor.3206a7d2.js\",\"f7f51\",\"Comment.2d681f30.js\",\"3JzPO\",\"WatchDialog.2e7f741e.js\",\"hsCH6\",\"PageContentRendererFabric.534c2f89.js\",\"68WuS\",\"EditorObjectSidebarPanel.23f41753.js\",\"gr9Xf\",\"ObjectSidebarPanelWrapper.6d2c95f0.js\",\"1TkAG\",\"IndentIcon.9ff859e8.js\",\"aLenh\",\"LiveDocSpotlightsTour.ce140f63.js\",\"aJJUY\",\"ObjectSidebarPanelWrapper.af8d7bfb.js\",\"b6JBs\",\"CompanyHubBreadcrumbs.682e6ac3.js\",\"lhCOg\",\"HubSettingsEntryButton.ae50a86f.js\",\"wTRL7\",\"ChangeHubNameDialog.1f73be0d.js\",\"eeBOH\",\"hub-hero-image.d6790ccb.png\",\"1GyAj\",\"BreadcrumbsDropdownContent.07cd0454.js\",\"36rXN\",\"MovePageDialog.d173addd.js\",\"lnCW7\",\"ExternalCollaboratorInSpaceNotify.1e2a8a9b.js\",\"j02A7\",\"ViewExternalCollaboratorsLink.5408e11b.js\",\"l5XQ1\",\"ViewSpaceExternalCollaboratorsDialog.2d6d1c33.js\",\"h4Nf7\",\"ExternalUserLozenge.79d1225e.js\",\"hA2SB\",\"GroupAndUserItem.956a4fbe.js\",\"hwiu3\",\"NavigationLockout.795533cf.js\",\"iHlO3\",\"empty-filter.16dda5ac.svg\",\"gERCO\",\"schemaLink.aa892cc4.js\",\"5tHTv\",\"mention.3a7c819b.js\",\"ev7SX\",\"GroupAndUserItem.3642b14c.js\",\"f96v0\",\"GroupAndUserItem.c0438612.js\",\"dBM33\",\"GroupAndUserItem.11b5ca99.js\",\"j4POW\",\"GroupAndUserItem.0e699a3a.js\",\"lookM\",\"user-header-for-space-with-guests-Light.1b10bf7d.svg\",\"2GHvs\",\"user-header-for-space-with-guests-Dark.3d8c1f10.svg\",\"ltXeo\",\"PageTree.ccd807cf.js\",\"dviIw\",\"CollapsibleSection.8222f6a3.js\",\"dkv9z\",\"PageTreeAfterIcon.e8ce8943.js\",\"9F7vX\",\"CreateContentPopover.450df0d5.js\",\"bAbyV\",\"top-nav.00f03e92.js\",\"dwffN\",\"GlobalCreateContentPopoverMenu.618d00a9.js\",\"kiDFE\",\"CreateSpaceMenuItem.3846639c.js\",\"7xv66\",\"ContentTreeOnboarding.3216d263.js\",\"6fU2k\",\"drag-handle.27b6520d.js\",\"lWi9V\",\"CreateSpaceMenuItemNav3.cda7e59d.js\",\"3tVyh\",\"CreateSpacePlusButton.96b53145.js\",\"iUB8p\",\"WhiteboardsPaywall.cf2c63af.svg\",\"1TlSS\",\"WhiteboardsPaywallDark.0948bce6.svg\",\"U7y88\",\"HelpPanel.789c3672.js\",\"1WRp0\",\"GlobalCreateContentPopoverMenu.a2577929.js\",\"hr1db\",\"DatabaseGAOnboarding.fdc4cc79.svg\",\"h4qu8\",\"LiveDocsIntroGif.d2fc0787.gif\",\"j7hKO\",\"LiveDocIntroGADark.45e6357d.svg\",\"7yu5V\",\"LiveDocIntroGALight.8a32f41a.svg\",\"5TJ4V\",\"WhiteboardExperimentSpotlightImage.49c94c1b.svg\",\"98W0w\",\"GlobalCreateContentPopoverMenu.24cb610e.js\",\"4Dabn\",\"ContextualCreateContentPopoverMenu.4bfc02d5.js\",\"hvHZS\",\"TemplatePreview.78d6e797.js\",\"6JdS4\",\"blogPostIcon.e3cb4562.svg\",\"5fnDv\",\"loadingErrorIcon.3c97c605.svg\",\"843sJ\",\"TemplatePreview.0c685418.js\",\"bupWa\",\"PopupPreview.e2fbad41.js\",\"3yGMH\",\"displayErrorIcon.3bd706b2.svg\",\"5Ixal\",\"CreateFolderPopoverItemSpotlight.0dc0692c.svg\",\"jzQ6f\",\"BlankPageQuickActions.ddb45102.js\",\"8oWxD\",\"grid.d55e7d8c.js\",\"70aiP\",\"CreateFromTemplate.91b6d676.js\",\"ebtUB\",\"HelpPanel.d3324046.js\",\"l9Ahd\",\"HelpPanel.runtime.2cc7d4af.js\",\"avfAy\",\"ContextualCreateContentPopoverMenu.cffb923f.js\",\"hjl2g\",\"SmartButtonConfigPanel.b292efb7.js\",\"lhkXg\",\"SmartButton.4de6a64c.js\",\"9mjQR\",\"EndOfPageRecommendation.00bd5e45.js\",\"djzzD\",\"PageLabelsAutomationDiscovery.fed51a52.js\",\"4tUsp\",\"PageLabelsAutomationDiscovery.90a1c126.js\",\"fQ1rW\",\"PageLabelsAutomationDiscovery.eff4fc98.js\",\"jQFGH\",\"PageLabelsAutomationDiscovery.runtime.aedfdf55.js\",\"kQvbt\",\"PageLabelsAutomationDiscovery.ee9e9312.js\",\"jQFGH\",\"PageLabelsAutomationDiscovery.runtime.aedfdf55.js\",\"f7WA2\",\"SlackDiscoveryDialog.3f284d89.js\",\"eRzO9\",\"BulkChangePageOwnerDialog.5a0fcf1d.js\",\"1rMtp\",\"PagePublishAutomationDiscoveryDialog.562d35e9.js\",\"jdEwy\",\"JiraLinkAutomationDiscoveryDialog.06bd01b0.js\",\"696ho\",\"WhiteBoardPublishDiscoveryDialog.4bad5781.js\",\"1NKZf\",\"AutomationDiscoveryHoverPageTitleMessage.367f233a.js\",\"6sAbi\",\"ArchivePageAutomationDiscovery.a500dc46.js\",\"11AeH\",\"AutomationDiscoveryHeader.6db01409.svg\",\"i4Ngf\",\"SmartButtonSpotlightHeader.b4b7c8dc.png\",\"gQSWJ\",\"chevron-right.ff398574.js\",\"77pyi\",\"SmartButtonConfigPanel.884ac71c.js\",\"fgNp8\",\"SmartButtonExtension.e2b7142f.js\",\"djlDY\",\"AutomationIcon.95ae515c.js\",\"jjWia\",\"TableOfContents.1d9d3ee3.js\",\"3ioZJ\",\"DateComponent.715d462a.js\",\"iTmpz\",\"EmojiComponent.4e0cff86.js\",\"8OJBc\",\"MentionComponent.847e5925.js\",\"fDwDZ\",\"StatusComponent.d7be8dfc.js\",\"fYcvL\",\"HelpPanel.0e86c3e9.js\",\"fBfrc\",\"ContextualCreateContentPopoverMenu.c780592f.js\",\"dZKCL\",\"ContextualCreateContentPopoverMenu.2e774ad1.js\",\"eJleA\",\"ContextualCreateContentPopoverMenu.9e0ab40c.js\",\"l9Ahd\",\"HelpPanel.runtime.2cc7d4af.js\",\"clpSH\",\"PageTreeQuickActions.403e1f2c.js\",\"13PnU\",\"QuickActionsContent.e508cb17.js\",\"kSVGa\",\"ChangeEditionNotificationDialog.f33d7ac0.js\",\"6rpul\",\"ArchivedPageBannerV2.e73c05cb.js\",\"dxDVc\",\"UnarchivePagesLoader.2cd5425d.js\",\"ktyyJ\",\"TrialFlags.b35b37f2.js\",\"cmcKh\",\"TrialFlags.0d9edc2f.js\",\"4yUSc\",\"PremiumLozenge.d6db761b.js\",\"ePA5l\",\"Lozenge.d54ac926.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"x8U2P\",\"AutoUpgradeAwarenessModal.6a72cb60.js\",\"bzMr5\",\"gestural-line.01cd284e.svg\",\"5ZKDh\",\"gestural-line-dark.981a995a.svg\",\"j4i4o\",\"background-dark.46d9946a.svg\",\"bJJdV\",\"background-light.c76a8e81.svg\",\"2Q7D6\",\"GuestAccess.0a003025.png\",\"lgkzA\",\"UnlimitedUserLimit.95d7cd0c.png\",\"hA7qR\",\"PageRestrictions.6ddf91dd.png\",\"8yrVy\",\"PageInsights.548fcd17.png\",\"aLvBu\",\"FreeUserSpot.bc2e68e1.svg\",\"UVILy\",\"FreeUserSpotDark.1362184e.svg\",\"fbLDC\",\"TakenUserSpot.aa0f71db.svg\",\"ebcMy\",\"TakenUserSpotDark.60435ee2.svg\",\"fqBFU\",\"ReverseTrialLozenge.963744c7.js\",\"2Fobu\",\"EndOfPageRecommendation.aeb1df3b.js\",\"3ysQD\",\"AutomationPopupContent.ef80e1a3.js\",\"awXdT\",\"error.b6351f9e.svg\",\"aOpoD\",\"empty-automation-list.9c7d0496.png\",\"7WcBh\",\"MovePageDialog.0cfd6338.js\",\"cQ2OK\",\"UnarchivePagesLoader.fba3e190.js\",\"kDklq\",\"UnarchivePagesLoader.595d2416.js\",\"50LrB\",\"UnarchivePagesLoader.06ac0e2a.js\",\"khV58\",\"PageSelectionTable.07409cc7.js\",\"2YKx2\",\"MovePageDialog.409c3b8e.js\",\"in6Mc\",\"NoChildrenBullet.3add963e.js\",\"bm3DR\",\"EmptyPageSelectionTable.c93c940f.js\",\"5IFtr\",\"fileCabinet.8e8cc872.svg\",\"2HL52\",\"QuickActionMenuBase.f9276aac.js\",\"e52Rm\",\"UnarchivePagesLoader.5b816c4d.js\",\"7dkWW\",\"ArchivedPageBannerV2.d06a37e1.js\",\"3uux1\",\"ArchivePagesLoader.0a05a439.js\",\"cPaXL\",\"ArchiveUpsellDialog.53ed6938.js\",\"7rEYM\",\"ShareButton.3c94f4fc.js\",\"anGwD\",\"BulkArchivePagesLoader.649825b6.js\",\"f0OaY\",\"ArchiveRemoteProcessContainer.31299f13.js\",\"hVNnP\",\"UpdateArchivedPageNoteDialog.5059a2bb.js\",\"9QyoN\",\"PageQuickActionAutomationMenu.62a8941c.js\",\"4xZ5N\",\"PageQuickActionAutomationMenu.c922f24c.js\",\"9YGIy\",\"DeleteNestedPagesAction.ef91bf8b.js\",\"iomzR\",\"DeletePageDialog.5b572d48.js\",\"k3BGs\",\"DeleteNestedPagesAction.82d2ff38.js\",\"adHzf\",\"DeleteNestedPagesAction.0dc4bec9.js\",\"4JUnA\",\"BulkDeletePagesAction.2a1bc15a.js\",\"5YvMC\",\"BulkChangeOwnerAction.8792da27.js\",\"4MnP8\",\"atlassian-icon.1175e11b.svg\",\"bXkeF\",\"BulkChangeStatusAction.6902ede9.js\",\"leIbB\",\"BulkChangeStatusAction.114c3db5.js\",\"65d3q\",\"SpaceAdminConfig.2ca3432b.js\",\"jE5XU\",\"SatisfactionSurveyFlag.d42db9d3.js\",\"f8xBv\",\"SatisfactionSurveyComponent.ec0f8806.js\",\"4csuu\",\"terrible.43df9387.svg\",\"ezTnP\",\"bad.1f02aedc.svg\",\"lKYkZ\",\"okay.fd894a28.svg\",\"eOIaN\",\"great.e17ca230.svg\",\"c1rvV\",\"amazing.0fceeb3a.svg\",\"9lDKI\",\"SatisfactionSurveyModal.ab9c9e11.js\",\"9FFAj\",\"SatisfactionSurveyOnlyTextboxComponent.3b41578b.js\",\"ljCe8\",\"EditorContentState.4942012f.js\",\"9DDT5\",\"EditorContentStateComponent.181dca13.js\",\"dzXtg\",\"WorkflowStatePageEntry.ff79400e.js\",\"4odwV\",\"WorkflowStatus.b444cc6f.js\",\"f3bIn\",\"GenericError.42a632b0.svg\",\"azlpK\",\"RendererContentStateWithSpotlight.2fdd967d.js\",\"50o6L\",\"PageHistoryContentState.3c63b7af.js\",\"9opeZ\",\"RendererContentState.270919b7.js\",\"1aFR7\",\"NestedChangeOwnerAction.98cd1a00.js\",\"Pp5sV\",\"NestedConvertPageToLiveDocAction.65e2d310.js\",\"lgZ1d\",\"BulkConvertPageToLiveDocAction.25571d73.js\",\"p4ay7\",\"CopyPageTreeContainer.a45b78d5.js\",\"i5Fj1\",\"data-classification.d025b741.js\",\"jnk96\",\"DataClassification.7b2e2f4b.js\",\"gEi5K\",\"NotFound.10564180.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"bn8Oy\",\"OverviewNotFound.d5cde81f.js\",\"4jFyQ\",\"icon-space-overview-empty.106059f9.svg\",\"3b99S\",\"EditorContentClassificationTag.92f02ff5.js\",\"1zPhe\",\"EditorDataClassification.e4ca3a9f.js\",\"avzJW\",\"EditorDataClassificationComponent.fffb3553.js\",\"4Oj5y\",\"ContentTypeClassification.47f2845d.js\",\"iJsKa\",\"ClassificationReadViewPopup.b589cfc0.js\",\"cQk37\",\"GenericAddClassificationButton.32d6c369.js\",\"58UdM\",\"ClassificationEditViewPopup.cb6bc581.js\",\"cEDfx\",\"DataClassificationHoverButton.14f53873.js\",\"9wTW2\",\"EditorClassificationTagWrapper.fb8e4374.js\",\"iLLJH\",\"MovePageDialog.8623dcd3.js\",\"cxO6v\",\"MovePageDialog.3ffdb255.js\",\"jZuk8\",\"MovePageDialog.5ad793b1.js\",\"5odbj\",\"ClassificationTagButtonError.2736aefc.js\",\"4Qstt\",\"ClassificationEditModal.5872e990.js\",\"fOLlY\",\"MovePageDialog.5027bda4.js\",\"f9QHk\",\"TreeMonitor.59b49c20.js\",\"9PeA0\",\"GrantAccessDialog.ef640bf0.js\",\"4mWJk\",\"GrantAccessFlag.17f8910c.js\",\"bfhXH\",\"RestrictionsButton.67e3d8be.js\",\"lk4cE\",\"RequestAccessPopup.455f797a.js\",\"TpLgp\",\"Controller.abc79579.js\",\"fnUik\",\"GeneralAccessLevelSelector.ebc9723f.js\",\"Ohbxv\",\"PublicLinkPermissionsSpotlight.328990b4.svg\",\"gjKgt\",\"PublicLinkButtonSpotlight.9320b1e3.svg\",\"k0hwN\",\"ShareToSlack.78bd40b7.js\",\"lVO4z\",\"cs.66d17b1d.js\",\"2FVbf\",\"da.45f5bf76.js\",\"ljo6M\",\"de.87ff8d2a.js\",\"9lT7a\",\"en_GB.3f736bc3.js\",\"cNgJs\",\"en.53674b7a.js\",\"aHeMo\",\"en_ZZ.90d281af.js\",\"8d6ia\",\"es.44f7b6ae.js\",\"jh8UJ\",\"fi.bd46bce1.js\",\"bYwCr\",\"fr.854524fc.js\",\"11NiT\",\"hu.21eb6dc5.js\",\"le8VA\",\"it.111da4a0.js\",\"1beJ2\",\"ja.25f13916.js\",\"1tXCh\",\"ko.c7b3c730.js\",\"jzP8g\",\"nb.6ab8a8d0.js\",\"dJY66\",\"nl.b11fd7f9.js\",\"4foYW\",\"pl.200ddf23.js\",\"j0yc3\",\"pt_BR.3fad7d31.js\",\"RfEmw\",\"ru.64b44490.js\",\"5DOlG\",\"sv.812498a9.js\",\"6rD7n\",\"tr.6280d059.js\",\"1e62a\",\"th.646e04f8.js\",\"eLsCU\",\"uk.87a103d8.js\",\"g9qHs\",\"vi.352e605d.js\",\"2ri5s\",\"zh_TW.40e2425f.js\",\"3k60n\",\"zh.af15c051.js\",\"hxIYN\",\"integration-primer.cead19d9.svg\",\"5oKDR\",\"disabled-alert.0ba0a4e5.svg\",\"13QWg\",\"in-trial-feature-gates-banner.6d409b59.js\",\"85liN\",\"InspectPermissionsDialog.f2b66603.js\",\"14XOE\",\"InspectPermissionsDialog.badc531c.js\",\"69XGw\",\"InspectPermissionsEntryPoint.2e564f52.js\",\"gkmZg\",\"DevToolsDialog.0fbe51c2.js\",\"1V0Ha\",\"RestrictionsDialog.7ca1324c.js\",\"iO9O1\",\"personal_space.c63f5733.png\",\"gZKQW\",\"QuickActionsContent.714933ca.js\",\"fno6o\",\"RestrictionsDialogMountPoint.d76a2307.js\",\"inQqk\",\"RestrictionsDialog.af167040.js\",\"9NxYX\",\"no-restriction-illustration-Light.a376c323.svg\",\"lpZU0\",\"no-restriction-illustration-Dark.8da66227.svg\",\"kgrX3\",\"no-restriction-illustration-pencil-Light.bcc52320.svg\",\"bRk6k\",\"no-restriction-illustration-pencil-Dark.5e6368e9.svg\",\"1DRtS\",\"no-restrictions-illustration-external-share-Light.85b8ab71.svg\",\"hhpRR\",\"no-restrictions-illustration-external-share-Dark.dff9aa3b.svg\",\"42PSc\",\"AutomationPremiumTip.2afe60f6.js\",\"ipK41\",\"NativeCollabComponent.db99fbe9.js\",\"3bo82\",\"ShareButton.e28f1ab1.js\",\"hdBGO\",\"ShareButton.c0349566.js\",\"jOlrD\",\"LazyShareForm.2b30daf0.js\",\"2jdQ1\",\"LazyShareFormNext.17f8b2c6.js\",\"8M2wy\",\"LazyShareFormNext.d5392d75.js\",\"k9kY4\",\"share.f4842dff.js\",\"ew1CD\",\"ShareButtonLite.fa48e834.js\",\"2VACG\",\"RestrictionsUpsellDialog.574928e6.js\",\"PNyg1\",\"InlineRename.8795ff54.js\",\"hsQeU\",\"MovePageDialog.20a832ea.js\",\"3L1uC\",\"PageTreeErrorComponent.1856c08c.js\",\"dhqJV\",\"FooterCreateButtons.4adb171a.js\",\"67Pvd\",\"ContentTreeOnboarding.aca29074.js\",\"e19Zv\",\"LiveDocsIconTile.fa672fcb.js\",\"d1QkY\",\"TreeBottomCreateButton.52a6f663.js\",\"fnoJZ\",\"HomepageIcon.564a21b9.js\",\"6gau7\",\"DraftLozenge.e75ff55b.js\",\"mltxm\",\"HelpPanel.697425e8.js\",\"dQVTa\",\"HelpPanel.runtime.dcd70275.js\",\"5zDuS\",\"NativeCollabComponent.58d75307.js\",\"dQVTa\",\"HelpPanel.runtime.dcd70275.js\",\"aoUod\",\"MoveBlogModal.e7b55dcc.js\",\"hHYS0\",\"ModernizedBreadcrumbsIndentIcon.10e32cf1.js\",\"hHIPg\",\"ObjectSidebarControl.52f44cea.js\",\"4g8hn\",\"AIPresentationModalWrapper.5cf4f7f2.js\",\"3Eu7W\",\"drag-handler.76334afd.js\",\"anP9P\",\"error.5fbc7fe9.png\",\"6cs5n\",\"FooterCommentsSummaryButton.b211d55c.js\",\"5lfr5\",\"FooterCommentsSummaryCombined.263b5c24.js\",\"1fnbu\",\"EditLabelDialogComponent.0fa955c6.js\",\"1kb22\",\"LabelsSelect.e2e65130.js\",\"5IJHO\",\"LabelsMovedChangeboarding.df08a25a.js\",\"a7qwF\",\"LabelsSelectErrors.a40b63ec.js\",\"fwFM0\",\"ViewPageLabels.93814a91.js\",\"1MDpw\",\"AudioBriefingChangeboardingIllustration.3bcea83c.svg\",\"KSMZE\",\"ObjectSidebarSpotlightTour.7e7ebf86.js\",\"dclpt\",\"ObjectSidebarControl.c221e8d6.js\",\"eHCfP\",\"ObjectSidebarControl.2dabf6b0.js\",\"3pwml\",\"AIButtonSpotlight.af8728e4.js\",\"XdJi8\",\"AudioPanelErrorIllustration.24fce6d6.svg\",\"26kHw\",\"AudioPanelErrorIllustrationDark.fd4f5286.svg\",\"bons8\",\"dark.6d30a270.svg\",\"1eGyz\",\"light.936b96f7.svg\",\"kYmQJ\",\"dark.90199792.svg\",\"150NM\",\"light.5ffcf568.svg\",\"eC1Ud\",\"FullPageEditorComponent.34c6bf8a.js\",\"kyJHs\",\"ObjectSidebarControl.52cb5096.js\",\"gAIhR\",\"ObjectSidebarControl.30656b1e.js\",\"1FzbR\",\"RedactionsDialog.c6efb508.js\",\"jrkFV\",\"ObjectSidebarControl.15b0a641.js\",\"lKP6d\",\"GetTheDetailsYouNeedDark.bbe9839d.gif\",\"4Yi9K\",\"GetTheDetailsYouNeedLight.9900190e.gif\",\"3v4Cg\",\"PageContentRendererFabric.962b65fa.js\",\"5VWLy\",\"PageContentRendererFabric.22e23364.js\",\"1x8aW\",\"PageContentRendererFabric.17e07435.js\",\"793O3\",\"PageContentRendererFabric.d26aff10.js\",\"3Kg3S\",\"CreateComponent.7485d96c.js\",\"aHCaB\",\"ViewComponent.197d0d1d.js\",\"eh78s\",\"PageContentRendererFabric.70905dac.js\",\"hpN5y\",\"ForgeAction.d037a825.js\",\"eM4KW\",\"TextHighlighter.5a1883e8.js\",\"bGzhS\",\"ByLineForgeApp.a8fa1888.js\",\"bf0yj\",\"modal-dialog.fdcb4a96.js\",\"eMbal\",\"loading-button.243d3ae5.js\",\"cjJTJ\",\"section-message.b7da860f.js\",\"jeyta\",\"no-results.603cf20f.svg\",\"4gZEH\",\"ByLineForgeApp.beead304.js\",\"hY7D1\",\"FullPageEditorComponent.c6570dbb.js\",\"8Xlsv\",\"FullPageEditorComponent.runtime.1890042e.js\",\"8Xlsv\",\"FullPageEditorComponent.runtime.1890042e.js\",\"bdzih\",\"ContentActionForgeApp.53b38e0b.js\",\"cwpVK\",\"ContextMenuForgeApp.953f3fda.js\",\"87cDu\",\"GlobalPageForgeApp.c555b9f3.js\",\"iXr0W\",\"GlobalSettingsForgeApp.3e9e63ba.js\",\"ccJug\",\"HomepageFeedForgeApp.0753dd27.js\",\"irYLY\",\"SpaceSettingsForgeApp.3bc18d15.js\",\"ldtPf\",\"SpacePageForgeApp.84366981.js\",\"6wcNV\",\"CustomContentForgeApp.24472fe6.js\",\"i9jMB\",\"BackgroundScriptForgeApp.42dd586a.js\",\"aFNXd\",\"PageBannerForgeApp.6ae94145.js\",\"aSmvL\",\"DefinitionAction.f88da7a2.js\",\"3zuUe\",\"quote.07a39900.js\",\"ekztv\",\"office-building.e0879a8c.js\",\"63hQz\",\"documents.93344b01.js\",\"dPdkf\",\"file.c340fb5e.js\",\"kwiXK\",\"ReadingAidsChangeboardingModal.06d81d4e.js\",\"cF8dp\",\"changeboardingModalImage.516388c9.svg\",\"9j6kV\",\"PageContentRendererFabric.runtime.8f102440.js\",\"e9VVN\",\"PageContentRendererTiny.f9f8b895.js\",\"8CeYz\",\"Renderer.a059a7a9.js\",\"kSjKH\",\"ProfileCard.5e900eb0.js\",\"lvR1M\",\"recent.b77737cb.js\",\"dUEf9\",\"location.2e32d18a.js\",\"1Y6tF\",\"main.ebf57254.js\",\"cGVng\",\"AgentProfileCard.0a0127f0.js\",\"St9Nk\",\"AgentProfileCard.40c9742c.js\",\"heWL2\",\"body.f6bdae8b.js\",\"47FAO\",\"body.b43d4b78.js\",\"i27dG\",\"EditorLoader.607b4cb2.js\",\"3S6Uf\",\"initialize.bcbccb30.js\",\"hDCAz\",\"panel.ab2ff1e4.js\",\"6AIMV\",\"mention.2402a926.js\",\"43hsF\",\"EditorLoader.282dd1af.js\",\"710vD\",\"editor.8e47d073.js\",\"9Cer0\",\"editor-plugins.098b58af.js\",\"8MJT8\",\"editor-plugins.05020252.js\",\"aqQdm\",\"editor-plugins.69121daf.css\",\"hZL0Z\",\"adg3-styles.0345a9dd.css\",\"kDJ6u\",\"wait.b55e6fef.gif\",\"lqsln\",\"warning.83e35a8f.png\",\"9ld2H\",\"ADG3-Editor-Icons.cc60d923.eot\",\"dwka9\",\"ADG3-Editor-Icons.c170c836.ttf\",\"h9OU0\",\"ADG3-Editor-Icons.45a9e586.woff\",\"aFaRR\",\"ADG3-Editor-Icons.529ae9e0.svg\",\"9tkO6\",\"adg3-styles.0dc93910.js\",\"dQy5b\",\"RedactedPlaceholder.630c51d3.js\",\"iq6Zv\",\"experiment-legacy-content-macro.8f5bcfa0.js\",\"8JZKd\",\"activity.ae8026bd.js\",\"dI2vi\",\"extension-handler.df171bfc.js\",\"chR0R\",\"mediaInline.4f2b11c5.js\",\"8hTWF\",\"InvalidExtension.c6fd8b57.js\",\"44W0y\",\"extension-handler.b6f91071.js\",\"5vvv9\",\"InvalidExtension.2002a69d.js\",\"17JTB\",\"modal.309784e9.js\",\"cMAQT\",\"DropboxIcon.3d99ee28.js\",\"aD89V\",\"dropbox.c3209b5c.js\",\"9n0AM\",\"dropboxscript.62f72250.js\",\"8AwXG\",\"ProjectLinker.9320cbbb.js\",\"j0KqR\",\"jira-board-light.49fc2d6c.png\",\"aEOsg\",\"jira-board-dark.4f2096de.png\",\"chv15\",\"jira-static-light.fe57e5bd.png\",\"5koHF\",\"jira-static-dark.ec3cbc0d.png\",\"6Z8WE\",\"en.db41dfb5.js\",\"dBjkU\",\"add.f68dbca1.js\",\"avCUM\",\"chevron-left.2065d919.js\",\"9Ylm4\",\"FullPageEditorComponent.d7b916be.js\",\"eFHVS\",\"extensibility.711ccd5f.js\",\"djfev\",\"ConfigPanelFieldsLoader.96d73fca.js\",\"eoIpr\",\"add-circle.72092d8c.js\",\"2zD7d\",\"renderer-extension-handler.0bf3fddc.js\",\"6IjKj\",\"TemplateVariableDialogComponent.8ea1cf4a.js\",\"aXsk5\",\"FullPageEditorComponent.0e710749.js\",\"7D2ux\",\"FullPageEditorComponent.runtime.03afba63.js\",\"cHp04\",\"FullPageEditorComponent.e4e107db.js\",\"8rpJ0\",\"FullPageEditorComponent.runtime.7edd0d90.js\",\"7D2ux\",\"FullPageEditorComponent.runtime.03afba63.js\",\"8rpJ0\",\"FullPageEditorComponent.runtime.7edd0d90.js\",\"iHZci\",\"MainButtons.b17f8cb9.js\"]"));


//# sourceMappingURL=ClassicEditorContextProvider.d4ac6afe.js.map
